import { FileInfo, FileRestrictions } from '@progress/kendo-angular-upload';
import { SortDescriptor } from '@progress/kendo-data-query';
import { KwikKeyConfigType, V6FrameConfigType, V6FrameType, V6ProductType } from '../enums';

//#region advance search
export interface IAdvanceSearchLbl {
  defaultViewLbl: string;
  tileViewLbl: string;
  listViewLbl: string;
  finishLowercaseLbl: string;
  imageLbl: string;
  paintLbl: string;
  sizeLbl: string;
  quantityLbl: string;
  descriptionLbl: string;
  itemLbl: string;
  listPriceLbl: string;
  selectionLbl: string;
  addToCartLbl: string;
  addToQuoteLbl: string;
  buildLbl: string;
  categoryLbl: string;
  finishUppercaseLbl: string;
  selectAllLbl: string;
  tileNoRecordLbl: string;
  priceLbl: string;
  tileItemPerPageLbl: string;
  ofLbl: string;
  itemsLbl: string;
  clearSearchLbl: string;
}
//#endregion
//#region quick add
export interface IQuickAddLabel {
  idDescriptionLbl: string;
  finishLbl: string;
  setDefaultLbl: string;
  defaultLbl: string;
  paintLbl: string;
  sizeLbl: string;
  quantityLbl: string;
  uomLbl: string;
  addToCartLbl: string;
  clearSelectionLbl: string;
  buildBuyLbl: string;
  defaultInfoLbl1: string;
  defaultInfoLbl2: string;
  submitBtnLbl1: string;
  submitBtnLbl2: string;
}
//#endregion

//#region BuildPak Attribute
export interface IBuildPakAttribute {
  id: number;
  v6ReferenceCode: string;
  name: string;
  publishedName: string;
  type: string;
  options: IAttributeOption[];
  value: string;
  code: string;
  show: boolean;
  isDirty: boolean;
  isPublished: boolean;
  isReported: boolean;
  isError: boolean;
  errorMessage: string;
}

export class BuildPakAttribute implements IBuildPakAttribute {
  show: boolean;
  id: number;
  v6ReferenceCode: string;
  name: string;
  publishedName: string;
  type: string;
  options: IAttributeOption[];
  value: string;
  isDirty: boolean;
  code: string;
  isPublished: boolean;
  isReported: boolean;
  isError: boolean;
  errorMessage: string;
  constructor() {
    this.value = '';
    this.code = '';
    this.isDirty = false;
    this.show = true;
    this.isPublished = true;
    this.isReported = true;
    this.isError = false;
    this.errorMessage = '';
  }

}
export interface IAttributeOption {
  id: number;
  v6ReferenceCode: string;
  code: string;
  name: string;
  description: string;
  value: string;
  show: boolean;
}
export class AttributeOption implements IAttributeOption {
  code: string;
  show: boolean;
  id: number;
  v6ReferenceCode: string;
  name: string;
  description: string;
  value: string;
  constructor() {
    this.show = true;
  }

}
//#endregion
//#Invoice Inquiry models
export interface IInvoiceInquiryLbl {
  amountDueLbl: string;
  checkNumberLbl: string;
  exportToExcelLbl: string;
  exportToPDFLbl: string;
  invoiceDateLbl: string;
  invoiceInquiryLbl: string;
  invoiceNumberLbl: string;
  invoiceStatusLbl: string;
  invoiceTypeLbl: string;
  jobNameLbl: string;
  marketSegmentLbl: string;
  originalAmountLbl: string;
  poLbl: string;
  customerNumberLbl: string;
  customerNameLbl: string;
  paymentStatusLbl: string;
  downloadInvoiceLbl: string;
}
export interface IInvoiceInquiryDetailsLbl {
  relatedinvoiceLbl: string;
  invoiceHeaderLbl: string;
  billingAddressLbl: string;
  shippingAddressLbl: string;
  invoiceNumberLbl: string;
  grossAmountLbl: string;
  taxableAmountLbl: string;
  invoiceDateLbl: string;
  openAmountLbl: string;
  taxLbl: string;
  invoiceDetailsLbl: string;
  orderNumberLbl: string;
  lineLbl: string;
  orderDateLbl: string;
  orderTypeLbl: string;
  qtyLbl: string;
  uomLbl: string;
  itemLbl: string;
  descriptionLbl: string;
  unitPriceLbl: string;
  extendedPriceLbl: string;
  shipFromLbl: string;
  statusLbl: string;
  exportToPdfLbl: string;
  exportToExcelLbl: string;
  nonTaxableLbl: string;
  kdRefLbl: string;
  customerNumberLbl: string;
  customerNameLbl: string;
}
export interface IGetInvoiceBody {
  invoiceNumber: number;
  fromDate: string;
  toDate: string;
}
export interface IGetInvoicePdfBody {
  invoiceNumber: number;
  invoiceType: string;
  customerNumber: string;
}
export interface IGetInvoiceDetailsBody {
  invoiceNumber: string;
  orderBu: string;
  orderNumber: string;
}
export interface IInvoiceInquiryDropDown {
  invoiceNumber: number;
  orderNumber: string;
}
export interface IInvoiceInquiry {
  invoiceNumber: number;
  invoiceDate: string;
  invoiceDateUIString: string;
  type: string;
  jobName: string;
  originalAmount: string;
  amountDue: string;
  checkNumber: string;
  marketSegment: string;
  invoiceStatus: string;
  billTo: string;
  shipTo: string;
  orderBu: string;
  orderNumber: string;
  invoiceDateAsDate: Date;
  poNumber: string;
  grossAmount: string;
  openAmount: string;
  taxableAmount: string;
  tax: string;
  nonTaxableAmount: string;
  kdReferenceNumber: string;
  orderType: string;
  paymentStatus: string;
  selectedForPayment: boolean;
  paymentComments: IPaymentComment[];
  calculatedAmountDue: number;
  paymentReasonRequired: boolean;
  paymentReason: string;
  paymentReasonCharCounter: string;
  dueDate: string;
  dueDateUIString: string;
  dueDateAsDate: Date;
  discountAvailable: number;
  isDiscountApplicable: boolean;
  payAmount: number;
}
export interface IInvoicePayment {
  invoiceNumber: number;
  invoiceDate: Date;
  type: string;
  jobName: string;
  originalAmount: number;
  finalAmountDue: number;
  originalAmountDue: number;
  amountPaid: number;
  poNumber: string;
  grossAmount: string;
  openAmount: string;
  //calculatedAmountDue: number;
  //paymentReasonRequired: boolean;
  paymentReason: string;
  dueDate: Date;
  discountAvailable: number;
  isDiscountApplicable: boolean;
}
export interface IPaymentComment {
  isError: boolean;
  message: string;
  show: boolean;
  type: string;
}
export class PaymentComment implements IPaymentComment {
  isError: boolean;
  message: string;
  show: boolean;
  type: string;
}
export interface IPaymentTransaction {
  trackerId: string;
}
export interface IInvoicePay {
  invoiceNumber: number;
  amountDue: number;
  calculatedAmountDue: number;
  discountAvailable: number;
  finalAmountDue: number;
  originalAmount: number;
  invoiceDate: Date;
  amountPaid: number;
  dueDate: Date;
  type: string;
  poNumber: string;
  jobName: string;
  paymentReason: string;
}
export class InvoicePay implements IInvoicePay {
  invoiceNumber: number;
  amountDue: number;
  calculatedAmountDue: number;
  discountAvailable: number;
  finalAmountDue: number;
  originalAmount: number;
  invoiceDate: Date;
  amountPaid: number;
  dueDate: Date;
  type: string;
  poNumber: string;
  jobName: string;
  paymentReason: string;
  discountStatus: number;//1->honored, 2->taken by user, 3->NA
  discountComment: string;
  discountTaken: number;
}
export interface IACHTransaction {
  userName: string;
  fullName: string;
  firstName: string;
  lastName: string;
  customerNumber: number;
  //emailId: string;
  invoices: IInvoicePay[];
  customerName: string;
  email: string;
}

export class ACHTransaction implements IACHTransaction {
  userName: string;
  fullName: string;
  firstName: string;
  lastName: string;
  customerNumber: number;
  browserName: string;
  //emailId: string;
  invoices: InvoicePay[];
  customerName: string;
  email: string;
}

export interface ICCTransaction {
  userName: string;
  fullName: string;
  firstName: string;
  lastName: string;
  customerNumber: number;
  //emailId: string;
  invoices: IInvoicePay[];
  customerName: string;
  email: string;
}

export class CCTransaction implements ICCTransaction {
  userName: string;
  fullName: string;
  firstName: string;
  lastName: string;
  customerNumber: number;
  browserName: string;
  //emailId: string;
  invoices: InvoicePay[];
  customerName: string;
  email: string;
}



export class TestTracker {
  trackerId: string;
  dateGenerated: Date;
}
//#endregion
//#region OrderInquiry
export interface IOrderInquiryLbl {
  jobNamelbl: string;
  jobNumberlbl: string;
  kdReflbl: string;
  orderDatelbl: string;
  orderNumberlbl: string;
  orderTypeLbl: string;
  polbl: string;
  scheduleDatelbl: string;
  shipFromlbl: string;
  shipTolbl: string;
  exportToExcelLbl: string;
  exportToPDFLbl: string;
  customerNumberLbl: string;
  customerNameLbl: string;
}
export interface IOrderInquiry {
  orderType: string;
  orderNumber: number;
  orderBu: string;
  jobName: string;
  jobNumber: string;
  kdReference: string;
  orderDate: string;
  scheduleDate: string;
  orderDateUIString: string;
  scheduleDateUIString: string;
  poNumber: string;
  shipFrom: string;
  shipTo: string;
  billTo: string;
  orderDateAsDate: Date;
  scheduleDateAsDate: Date;
  statusId: number;

}
export interface IOrderDetailsHeader {
  orderType: string;
  orderNumber: number;
  jobName: string;
  jobNumber: string;
  orderDate: string;
  orderDateUIString: string;
  shipFrom: string;
  shipTo: string;
  billTo: string;
  cscName: string,
  cscPhone: string,
  invoiceLineDetail: string;
}
//Order details
export interface IOrderInquiryDetailsLbl {
  orderHeaderLbl: string;
  billingAddressLbl: string;
  shippingAddressLbl: string;
  soLbl: string;
  poLbl: string;
  shippingFromLbl: string;
  jobNumberLbl: string;
  OrderDateLbl: string;
  orderDetailsLbl: string;
  invoiceDetailsLbl: string;
  trackShipmentLbl: string;
  exportToPdfLbl: string;
  exportToExcelLbl: string;
  lineLbl: string;
  orderDateLbl: string;
  scheduleDateLbl: string;
  qtyLbl: string;
  uomLbl: string;
  itemLbl: string;
  paintLbl: string;
  listPriceLbl: string;
  itemDescLbl: string;
  multiplierLbl: string;
  statusLbl: string;
  shipDateLbl: string;
  invoiceNumberLbl: string;
  orderTypeLbl: string;
  descriptionLbl: string;
  unitPriceLbl: string;
  extendedPriceLbl: string;
  shipFromLbl: string;
  shipmentIdLbl: string;
  carrierLbl: string;
  proNoLbl: string;
  billOfLading: string;
  noOfBoxesLbl: string;
  totalWeightLbl: string;
  cscNameLbl: string;
  cscPhoneLbl: string;
  totalPriceLbl: string;
  grossAmountLbl: string;
  taxableAmountLbl: string;
  invoiceDateLbl: string;
  openAmountLbl: string;
  taxLbl: string;
  nonTaxableLbl: string;
  kdRefLbl: string;
  customerNumberLbl: string;
  customerNameLbl: string;
  relatedInvoiceLbl: string;
}
export interface IOrderInquiryDetails {
  lineNumber: number;
  itemNumber: string;
  quantity: string;
  uom: string;
  paint: string;
  description: string;
  status: string;
  listPrice: string;
  multiplier: string;
  orderDate: string;
  shipDate: string;
  orderDateUIString: string;
  scheduleDateUIString: string;
  shipDateUIString: string;
  scheduleDateAsDate: Date;
  orderDateAsDate: Date;
  shipDateAsDate: Date;
  cmp: number;
  extendedPrice: number;
  statusId: number;
  nextStatusId: number;
  ackHold: string;
}
//Invoice details
export interface IInvoiceInquiryDetails {
  invoiceNumber: number;
  lineNumber: string;
  orderType: string;
  quantity: string;
  uom: string;
  itemNumber: string;
  itemDescription: string;
  status: string;
  unitPrice: string;
  extendedPrice: string;
  shipFrom: string;
  shipTo: string;
  grossAmount: string;
  openAmount: string;
  taxableAmount: string;
  tax: string;
  nonTaxableAmount: string;
  jobName: string;
  invoiceDateUIString: string;
}
//Track Shipment
export interface ITrackShipment {
  shipmentId: number;
  carrier: string;
  proNo: string;
  billOfLoading: string;
  noOfBoxes: string;
  totalWeight: string;
  shipDateUIString: Date;
  trackChildShipments: ITrackChildShipment[];
}
//Track Shipment Child
export interface ITrackChildShipment {
  shipmentid: string;
  boxno: number;
  item: string;
  itemdescription: string;
  itemWeight: string;
  quantity: number;
  lineNumber: number;
  originalLineNumber: number;
}

export interface IGetOrdersInquiryBody {
  customerNumber: string;
  fromDate: Date;
  toDate: Date;
}
export interface IGetOrdersDetailsBody {
  orderNumber: string;
  orderBu: string;
}
export interface IGetOrderInvoiceDetailsBody {
  orderNumber: string;
  orderBu: string;
}
export interface IGetOrderShipmentDetailsBody {
  orderNumber: string;
  orderBu: string;
}
export interface IFreightOrder {
  orderType: string;
  orderNumber: number;
  orderBu: string;
  jobName: string;
  jobNumber: string;
  kdReference: string;
  orderDate: string;
  scheduleDate: string;
  orderDateUIString: string;
  scheduleDateUIString: string;
  poNumber: string;
  shipFrom: string;
  shipTo: string;
  billTo: string;
  orderDateAsDate: Date;
  scheduleDateAsDate: Date;
  statusId: number;

}
export class FreightOrder implements IFreightOrder {

  orderType: string;
  orderNumber: number;
  orderBu: string;
  jobName: string;
  jobNumber: string;
  kdReference: string;
  orderDate: string;
  scheduleDate: string;
  orderDateUIString: string;
  scheduleDateUIString: string;
  poNumber: string;
  shipFrom: string;
  shipTo: string;
  billTo: string;
  orderDateAsDate: Date;
  scheduleDateAsDate: Date;
  statusId: number;

}

export class FreightClaimHeader {
  claimHeaderId: string;
  claimNumber: string;
  claimTypeId: string;
  claimTypeName: string;
  commentByUser: string;
  poNumber: string;
  jobName: string;
  soNumber: number;
  orderType: string;
  customerNumber: number;
  shipFrom: string;
  shipTo: string;
  raisedBy: string;
  raisedOn: Date;
  statusName: string;//approved, rejected, on hold, raised
  statusId: string;
  updatedBy: string;
  details: FreightClaimDetails[];
  carrierInspectionReports: ClaimDoc[];
  damagedMaterialPhotos: ClaimDoc[];
  jobNumber: string;
  customerName: string;
  kdReference: string;
  orderBu: string;
  orderDate: Date;
  scheduleDate: Date;
  comments: ClaimComment[];
  commentToUser: string;
  qualityDeptEmail: string;
  internalNotes: string;
  raisedByUserEmail: string;
  //projectManagerName: string;
  //projectManagerEmail: string;
  //salesRepName: string;
  //salesRepEmail: string;
  requestTypeId: string;
  requestTypeName: string;
  projectManagerSalutation: string;
  projectManagerEmail: string;
  projectManagerJDEName: string;
  salesRepName: string;
  salesRepEmail: string;
  salesRepJDEName: string;
  freightCost: number;
  freightPrice: number;
}
export class FreightClaimDetails {
  claimHeaderId: string;
  claimDetailId: string;
  shipmentId: number;
  items: FreightClaimItem[];
  carrier: string;
  proNo: string;
  noOfBoxes: string;
  totalWeight: string;
  billOfLading: string;
  shipDate: Date;
}

export class FreightClaimItem {
  claimHeaderId: string;
  claimDetailId: string;
  claimItemId: string;
  shipmentId: number;
  boxNo: number;
  itemNumber: string;
  itemDescription: string;
  itemWeight: string;
  originalQuantity: number;
  claimedQuantity: number;
  approvedQuantity: number;
  unitPrice: number;
  extendedPrice: number;
  approvedPrice: number;
  unitCost: number;
  extendedCost: number;
  lineNumber: number;
}

export class ClaimDoc {
  claimHeaderId: string;
  displayOrder: number;
  fileName: string;
  uid: string;
  type: string;
  fullPath: string;
  uniqueName: string;
}

export class ClaimComment {
  claimHeaderId: string;
  commentText: string;
  commentType: string;
  dateCreated: Date;
  createdBy: string;
  commentId: string;
}



//#endregion
//#region Quote
export interface addItemToQuoteLbl {
  quoteLbl: string;
  jobNameLbl: string;
  marketSegmentLbl: string;
  leedLbl: string;
  addQuoteTitleLbl: string;
  addExistingQuoteLbl: string;
  addLbl: string;
  newQuoteLbl: string;
  orLbl: string;
  createLbl: string;
  cancelLbl: string;
  gotoQuoteLbl: string;
}
export interface IMangeQuoteLbl {
  KDQuoteHeadingLbl: string;
  KDQuoteLbl1: string;
  inHouseHeadingLbl: string;
  inHouseLbl1: string;
  requestQuoteHeadingLbl: string;
  requestQuoteLbl1: string;
  factoryQuoteHeadingLbl: string;
  factoryQuoteLbl1: string;
}
export interface IInhouseQuote {
  quoteCommonId: string;
  jobNumber: string;
  revision: string;
  jobName: string;
  leed: boolean;
  blast: boolean;
  marketSegment: string;
  totalBaseBid: number;
  quoteDate: string;
  quoteExpirationDate: string;
  customerContact: string;
  estimatorEmail: string;
  status: string;
  statusReasonText: string;
  quoteDateAsDate: Date;
  quoteExpirationDateAsDate: Date;
  downloadInProgress: boolean;
}

export interface IKDQuoteLbl {
  kdQuoteLbl: string;
  jobNumberLbl: string;
  revlbl: string;
  jobNameLbl: string;
  leedLbl: string;
  blastLbl: string;
  marketSegmentLbl: string;
  quoteDateLbl: string;
  expirationDateLbl: string;
  totalBaseBidLbl: string;
  statusLbl: string;
  actionLbl: string;
  exportToPdfLbl: string;
  exportToExcelLbl: string;
  addNewQuoteLbl: string;
  saveLbl: string;
  closeLbl: string;
  updateLbl: string;
  deleteConfirmLbl: string;
  yesLbl: string;
  noLbl: string;
  customerNumberLbl: string;
  customerNameLbl: string;
}
export interface IQuoteDetailHeaderLbl {
  jobNameLbl: string;
  leedLbl: string;
  marketSegmentLbl: string;
  quoteDateLbl: string;
  expirationDateLbl: string;
  jobNumberLbl: string;
  cancelLbl: string;
  updateLbl: string;
}
export interface IKDQuoteDetailLbl {
  quickAddLbl: string;
  addQuoteToCartLbl: string;
  cancelLbl: string;
  clearSelectionLbl: string;
  copyQuoteLbl: string;
  createNewRevisionLbl: string;
  saveLbl: string;
  closeLbl: string;
  deleteQuoteConfirmLbl: string;
  copyLbl: string;
  editLbl: string;
  expiredDateLbl: string;
  exportExcelLbl: string;
  exportPDFLbl: string;
  extPriceLbl: string;
  extrusionLbl: string;
  finishLbl: string;
  itemDescriptionLbl: string;
  itemNumLbl: string;
  jobNameLbl: string;
  jobNumberLbl: string;
  leedLbl: string;
  lineLbl: string;
  listPriceLbl: string;
  marketSegmentLbl: string;
  multiplierLbl: string;
  itemLbl: string;
  pleaseConfirmLbl: string;
  printMaterialProposal: string;
  quantityLbl: string;
  quoteDateLbl: string;
  sizeLbl: string;
  successAddingQuoteToCart: string;
  totalPriceLbl: string;
  unitLbl: string;
  unitPriceLbl: string;
  uomLbl: string;
  updateLbl: string;
  paintLbl: string;
  actionLbl: string;
  importLbl: string;
  emptyQuoteLbl: string;
  deleteConfirmText1: string;
  yesLbl: string;
  noLbl: string;
  quoteUpdateSuccessLbl: string;
  errorOccuredLbl: string;
  nothingToRemoveLbl: string;
  emptyQuoteMessage: string;
  revisionCreatedLbl: string;
  copyQuoteMessage: string;
  deleteConfirmText2: string;
}

export interface IAddQuoteToCartResult {
  quote: IQuote;
  totalCartItemCount: number;
  quoteItemsAddedToCart: ICartItem[];
}
export interface IAddQuoteItemToCartResult {
  quote: IQuote;
  totalCartItemCount: number;
  quoteItemAddedToCart: ICartItem;
  existingInCartConfigItem: string;
}
export interface IAddQuoteToCartBody {
  quoteCommonId: string;
  //jobName: string;
  //userId: string;
}
export interface IAddQuoteItemToCartItemListBody {
  //quoteCommonId: string;
  quoteItemCommonId: string;
  itemType: number;
}

export interface IDeleteKdQuoteItemBody {
  quoteCommonId: string;
  quoteItemCommonId: string;
}
export interface IDeleteKdQuoteBody {
  quoteCommonId: string;
}
export interface IEmptyQuoteItemsBody {
  quoteCommonId: string;
}
export interface ICopyQuoteRequestBody {
  quoteCommonId: string;
  jobName: string;
  marketSegment: string;
  leed: boolean;
  customerNumber: string;
  //userId: string;
  marketSegmentId: string;
}
export interface IAddItemToKdQuoteItemListBody {
  lineNo: number;
  quoteCommonId: string;
  itemNumber: string;
  size: string;
  finish: string;
  finishValue: string;
  V6ReferenceValue: string;
  quantity: number;
  paint: string;
}
export interface IUpdateItemToQuoteBody {
  customerNumber: string;
  quoteItemCommonId: string;
  quoteCommonId: string;
  itemNumber: string;
  size: string;
  finish: string;
  finishValue: string;
  quantity: number;
  paint: string;
  lineNo: number;
  updatedQuantity: number;
  quoteItemCommonIdToDelete: string;
  paintName: string;
}
export interface IAddCartToQuoteBody {
  quoteCommonId: string;
  userName: string;
  customerNumber: string;
}


export interface ICreateQuoteItemRevisionBody {
  quoteCommonId: string;
  jobName: string;
  jobNumber: string;
  marketSegment: string;
  leed: boolean;
  //userId: string;
  customerNumber: string;
  revision: string;
}
export interface IPrintMaterialProposalBody {
  quoteCommonId: string;
  contactFullName: string;
  contactEmail: string;
  userName: string;
}
//export interface IGetAllInhouseQuotesBody {           //not being used anywhere
//  customerNumber: string;
//  userId: string;
//}
export interface IInHouseQuoteLbl {
  inHouseQuoteLbl: string;
  jobNumberLbl: string;
  revlbl: string;
  jobNameLbl: string;
  leedLbl: string;
  blastLbl: string;
  marketSegmentLbl: string;
  quoteDateLbl: string;
  expirationDateLbl: string;
  totalBaseBidLbl: string;
  statusLbl: string;
  customerContactLbl: string;
  statusTextLbl: string;
  estimatorLbl: string;
  printLbl: string;
  exportToPdfLbl: string;
  exportToExcelLbl: string;
  customerIdLbl: string;
  customerNumberLbl: string;
  customerNameLbl: string;
}
export interface IRequestAQuoteLbl {
  jobNameLbl: string;
  jobCityLbl: string;
  jobStateLbl: string;
  marketSegmentLbl: string;
  quoteTypeLbl: string;
  quoteRequestDate: string;
  bidDateLbl: string;
  leedLbl: string;
  indicateTypeLbl: string;
  blastLbl: string;
  customerSuppliedHardwareLbl: string;
  purchaseHardware: string;
  attachmentLbl: string;
  projectDetails: string;
  cancelButtonLbl: string;
  requestQuoteButtonLbl: string;
  noLbl: string;
  yesLbl: string;
  cancelConfirmLbl: string;
  quoteSubmittedLbl: string;
  thanksLbl: string;
  quoteGridLbl: string;
  submittedJobLbl: string;
  returnToInHouseQuoteLbl: string;
  addNewQuoteRequestLbl: string;
  requestSubmittedToKawneerLbl: string;
  confirmTitleLbl: string;
  invalidProjectDetailsLbl: string;
  noFilesUploadedLbl: string;
}
export interface IRequestAQuoteBody {
  jobName: string;
  jobCity: string;
  jobState: string;
  marketSegment: string;
  quoteType: string;
  requestDate: string;
  bidDate: string;

  leed: boolean;
  blast: boolean;
  customerSupplied: boolean;
  kawneerPurchasedHardware: boolean;
  // attachedFile      --Need to check for file upload
  projectDetails: string;
  customerNumber: string;
  createdBy: string;
  quoteTypeId: string;
  userName: string;
  userEmail: string;
  requestFiles: string[];
}
export class RequestAQuoteBody implements IRequestAQuoteBody {
  jobName: string;
  jobCity: string;
  jobState: string;
  marketSegment: string;
  quoteType: string;
  requestDate: string;
  bidDate: string;
  leed: boolean;
  blast: boolean;
  customerSupplied: boolean;
  kawneerPurchasedHardware: boolean;
  // attachedFile
  projectDetails: string;
  customerNumber: string;
  createdBy: string;
  quoteTypeId: string;
  userName: string;
  userEmail: string;
  requestFiles: string[];
}
//#region Factory quote models
export interface IFactoryQuoteLbl {
  customerNameLbl: string;
  customerNumberLbl: string;
  originDateLbl: string;
  quoteRequestDateLbl: string;
  emailConfirmationLbl: string;
  emailLbl: string;
  confirmEmailLbl: string;
  contactNameLbl: string;
  jobNameLbl: string;
  productTypeLbl: string;
  infillLbl: string;
  finishTypeLbl: string;
  glazingLbl: string;
  muntinsLbl: string;
  colorLbl: string;
  paintFinishLbl: string;
  glassSupplierLbl: string;
  glassSpecMakeupLbl: string;
  screensLbl: string;
  meshLbl: string;
  hardwareLbl: string;
  paintFinishInputLbl: string;
  anodizeColorLbl: string;
  specialFeaturesLbl: string;
  meshTypeLbl: string;
  specifyHardwareLbl: string;
  windloadLbl: string;
  pieceReceptorLbl: string;
  sillLbl: string;
  panningLbl: string;
  interiorTrimLbl: string;
  mullionsLbl: string;
  miscellaneousLbl: string;
  strapAnchorsLbl: string;
  projectCommentLbl: string;
  markTypeLbl: string;
  quantityLbl: string;
  sizeLbl: string;
  descriptionLbl: string;
  attachmentLblLbl: string;
  submitButtonLbl: string;
  cancelLbl: string;
  submitSuccessLbl: string;
  submitFailedLbl: string;
  noLbl: string;
  yesLbl: string;
  cancelConfirmLbl: string;
  quoteSubmittedLbl: string;
  submittedForProcessingLbl: string;
  thanksLbl: string;
  actioneNeededLbl: string;
  contactInfoLbl: string;
  returnToInHouseQuoteLbl: string;
  addNewQuoteRequestLbl: string;
  addNewTitle: string;
  deleteTitle: string;
  confirmTitleLbl: string;

}
export interface IRequestAFactoryQuoteSkill {
  markType: string,
  quantity: number,
  size: number,
  description: string
}
export interface IRequestAFactoryQuoteBody {
  quoteRequestDate: string;
  isReceiveEmail: boolean;
  email: string;
  confirmEmail: string;
  contactName: string;
  jobName: string;
  productType: string;
  infill: string;
  finishType: string;
  glazing: string;
  color: string;
  paintFinishDropDown: string;
  glassSupplier: string;
  glassSpecMakeup: string;
  screens: string;
  mesh: string;
  hardware: string;
  paintFinishInput: string;
  anodizeColor: string;
  specialFeatures: string;
  specifyMeshType: string;
  specifyHardware: string;
  muntins: string;
  windload: string;
  pieceReceptor: string
  sill: string;
  panning: string;
  interiorTrim: string;
  mullions: string;
  miscellaneous: string;
  strapAnchors: string;
  projectComment: string;
  // markType: string;
  // quantity: string;
  // size: string;
  // description: string;
  skills: IRequestAFactoryQuoteSkill[];
  // fileUpload
  filePaths: string[];
  customerNumber: string;
  userName: string;
  customerName: string;
}
export class RequestAFactoryQuoteBody implements IRequestAFactoryQuoteBody {
  quoteRequestDate: string;
  isReceiveEmail: boolean;
  email: string;
  confirmEmail: string;
  contactName: string;
  jobName: string;
  productType: string;
  infill: string;
  finishType: string;
  glazing: string;
  color: string;
  paintFinishDropDown: string;
  glassSupplier: string;
  glassSpecMakeup: string;
  screens: string;
  mesh: string;
  hardware: string;
  paintFinishInput: string;
  anodizeColor: string;
  specialFeatures: string;
  specifyMeshType: string;
  specifyHardware: string;
  muntins: string;
  windload: string;
  pieceReceptor: string
  sill: string;
  panning: string;
  interiorTrim: string;
  mullions: string;
  miscellaneous: string;
  strapAnchors: string;
  projectComment: string;
  // markType: string;
  // quantity: string;
  // size: string;
  // description: string;
  skills: IRequestAFactoryQuoteSkill[];
  // fileUpload
  filePaths: string[];
  customerNumber: string;
  userName: string;
  customerName: string;
}
//#endregion
export interface IQuoteDetailPayload {
  marketSegments: MasterData[];
  leeds: MasterData[];

}
export interface IRequestAFactoryQuotePayload {
  productTypes: MasterData[];
  infills: MasterData[];
  finishTypes: MasterData[];
  glazing: MasterData[];
  muntins: MasterData[];
  color: MasterData[];
  paintFinish: MasterData[];
  glassSupplier: MasterData[];
  screens: MasterData[];
  mesh: MasterData[];
  hardware: MasterData[];
  anodizeColor: MasterData[];

}
export interface IRequestAQuotePayload {
  marketSegments: MasterData[];
  quoteTypes: MasterData[];
  states: MasterData[];
}
export interface IAddQuoteBody {
  jobName: string;
  marketSegment: string;
  marketSegmentId: string;
  leed: boolean;
  customerNumber: string;
  userId: string;

}
export interface IUpdateQuoteBody {
  jobName: string;
  marketSegment: string;
  leed: boolean;
  customerNumber: string;
  quoteCommonId: string;
  marketSegmentId: string;
  jobNumber: string;
}
export class AddQuoteBody implements IAddQuoteBody {
  jobName: string;
  marketSegment: string;
  marketSegmentId: string;
  leed: boolean;
  customerNumber: string;
  userId: string;
}


export interface IGetKdQuoteDetailBody {
  quoteCommonId: string;
}
export interface IQuoteItem {
  lineNo: number;
  quoteCommonId: string;
  quoteItemCommonId: string;
  itemNumber: string;
  longItemNumber: string;
  itemDescription: string;
  itemType: number;
  finishValue: string;
  finish: string;
  quantity: number;
  size: string;
  basePrice: number;
  cmp: number;
  unitPrice: number;
  extendedPrice: number;
  availableFinishes: Array<IFinish>;
  currentSizes: Extrusion[];
  V6ReferenceValue: string;
  paint: string;

  updatedQuantity: number;
  updateInProgress: boolean;
  quoteItemCommonIdToUpdate: string;
  paintName: string;
  quoteItemCommonIdToDelete: string;
  customerNumber: string;
  userId: string;
  productId: number;
  productCode: string;
  isEmptyPaint: boolean;
}
export class QuoteItem implements IQuoteItem {
  lineNo: number;
  quoteCommonId: string;
  quoteItemCommonId: string;
  itemNumber: string;
  longItemNumber: string;
  itemDescription: string;
  itemType: number;
  finishValue: string;
  finish: string;
  V6ReferenceValue: string;
  paint: string;
  quantity: number;
  size: string;
  basePrice: number;
  cmp: number;
  unitPrice: number;
  extendedPrice: number;
  availableFinishes: IFinish[];
  currentSizes: Extrusion[];
  updatedQuantity: number;
  updateInProgress: boolean;
  quoteItemCommonIdToUpdate: string;
  paintName: string;
  quoteItemCommonIdToDelete: string;
  customerNumber: string;
  userId: string;
  productId: number;
  productCode: string;
  isEmptyPaint: boolean;
}
export interface IQuote {
  customerNumber: string;
  expirationDateForDisplay: string;
  jobName: string;
  jobNumber: string;
  leed: boolean
  marketSegment: string;
  quoteCommonId: string;
  quoteDate: Date;
  expirationDate: Date;
  quoteDateForDisplay: string;
  revision: string;
  status: string;
  totalBaseBid: number;
  userId: string;
  quoteItems: Array<IQuoteItem>
  marketSegmentObj: IMasterData;
  jobNumberRevision: string;
  updateInProgress: boolean;
  totalItemCountInQuote: number;
  quoteDisplayName: string;
}
export class Quote implements IQuote {
  updateInProgress: boolean;
  jobNumberRevision: string;
  marketSegmentObj: IMasterData;
  quoteItems: IQuoteItem[];
  customerNumber: string;
  quoteDate: Date;
  expirationDate: Date;
  expirationDateForDisplay: string;
  jobName: string;
  jobNumber: string;
  leed: boolean;
  marketSegment: string;
  quoteCommonId: string;
  quoteDateForDisplay: string;
  revision: string;
  status: string;
  totalBaseBid: number;
  userId: string;
  totalItemCountInQuote: number;
  quoteDisplayName: string;
}
export interface IGetQuoteBody {
  customerNumber: string;
  fromDate: Date;
  toDate: Date;
}
export interface IQuoteImportExcel {
  itemNumber: string;
  itemQuantity: string;
  paintNumber: string;
}
export class QuoteImportExcel implements IQuoteImportExcel {
  itemNumber: string;
  itemQuantity: string;
  paintNumber: string;
}
//#endregion
//#region Product Build & Buy
export interface IProductCategory {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
}
export class ProductCategory implements IProductCategory {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
}
export interface IProduct {
  id: number;
  name: string;
  description: string;
  productCode: string;
  productCodeId: number;
  productImageUrl: string;
}
export interface IV6Product {
  pushPullFin: string;
  quoteItemCommonId: string;
  translationFamily: string;
  id: number;
  productId: number;
  name: string;
  productCode: string;
  publishedName: string;
  templateDescription: string;
  template: IProductTemplate;
  type: string;
  typeId: string;
  isPublished: boolean;
  isActive: boolean;
  dependentAttributeIdList: string;
  dependentMacroIdList: string;
  dependencies: IGetProductDependencies;
  paintCode: string;
  paintName: string;
}

export interface IV6OptionTranslation {
  id: number;
  optionCode: string;
  optionTranslation: string;
  optionApplicableProducts: string;
  active: boolean;
}
export class V6OptionTranslation implements IV6OptionTranslation {
  id: number;
  optionCode: string;
  optionTranslation: string;
  optionApplicableProducts: string;
  active: boolean;
  constructor() {
    this.id = 0;
    this.optionCode = '';
    this.optionTranslation = '';
    this.optionApplicableProducts = '';
    this.active = false;
  }
}
export interface IV6OptionValueTranslation {
  id: number;
  optionCode: string;
  optionValueCode: string;
  optionValueTranslation: string;
  optionValueApplicableProducts: string;
  active: boolean;
}
export class V6OptionValueTranslation implements IV6OptionValueTranslation {
  id: number;
  optionCode: string;
  optionValueCode: string;
  optionValueTranslation: string;
  optionValueApplicableProducts: string;
  active: boolean;
  constructor() {
    this.id = 0;
    this.optionCode = '';
    this.optionValueCode = '';
    this.optionValueTranslation = '';
    this.optionValueApplicableProducts = '';
    this.active = false;
  }
}
export class V6Product implements IV6Product {
  quoteItemCommonId: string;
  translationFamily: string;
  id: number;
  productId: number;
  name: string;
  productCode: string;
  publishedName: string;
  templateDescription: string;
  template: ProductTemplate;
  type: string;
  typeId: string;
  isPublished: boolean;
  isActive: boolean;
  pushPullFin: string;
  constructor() {
    this.id = 0;
    this.productId = 0;
    this.name = '';
    this.productCode = '';
    this.publishedName = '';
    this.templateDescription = '';
    this.dependentAttributeIdList = '';
    this.dependentMacroIdList = '';
    this.type = '';
    this.isPublished = false;
    this.isActive = false;
  }
  dependencies: IGetProductDependencies;
  dependentAttributeIdList: string;
  dependentMacroIdList: string;
  paintCode: string;
  paintName: string;
}
export class Product implements IProduct {
  id: number;
  name: string;
  description: string;
  productCode: string;
  productCodeId: number;
  productImageUrl: string;
}

export interface IProductConfig {
  id: number;
  productId: number;
  description: string;
  name: string;
  imageUrl: string;
  isActive: boolean;
}

//#endregion

//#region MasterData Serice
export interface IState {
  stateCode: string;
  stateDescription: string;
}
export class State implements IState {
  stateCode: string;
  stateDescription: string;
}
export interface ICountry {
  countryCode: string;
  countryName: string;
  states: Array<IState>;
}
export class Country implements ICountry {
  states: IState[];
  countryName: string;
  countryCode: string;

}

export interface ICustomer {
  customerNumber: number;
  customerName: string;
  parentCustomerNumber: number;
  parentCustomerName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  county: string;
  country: string;
  language: string;
  isPOrequired: string;
  billingType: string;
  phoneNumber: string;
  isActive: boolean;
  isDefault: boolean;

  // local  stateManagement
  isSelected: boolean;
  territoryCode: string;
  territoryDescription: string
  paymentTerms: string;
  locationCode: string;
  /*Sample Product Fullfillment*/
  regionCode: string;
  /*Sample Product Fullfillment*/
}
export class Customer implements ICustomer {
  isDefault: boolean;

  customerNumber: number;
  customerName: string;
  parentCustomerNumber: number;
  parentCustomerName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  county: string;
  country: string;
  language: string;
  isPOrequired: string;
  billingType: string;
  phoneNumber: string;
  isSelected: boolean;
  isActive: boolean;
  territoryCode: string;
  territoryDescription: string;
  paymentTerms: string;
  locationCode: string;
  /*Sample Product Fullfillment*/
  regionCode: string;
  /*Sample Product Fullfillment*/
}

export interface ICustomerSuggestion {
  customerName: string;
  customerNumber: string;
  customerNameToDisplay: string;
  fullCustomer: string
  paymentTerms: string;
  currencyCode?: string;
}
export class CustomerSuggestion implements ICustomerSuggestion {
  customerName: string;
  customerNumber: string;
  customerNameToDisplay: string;
  fullCustomer: string;
  paymentTerms: string;
  currencyCode?: string;
}

export interface ICustomerArchiveAddress {
  customerNumber: number;
  isActive: boolean;
  isDefault: boolean;

  updateInProgress: boolean;
}
export class CustomerArchiveAddress implements ICustomerArchiveAddress {
  customerNumber: number;
  isActive: boolean;
  isDefault: boolean;

  updateInProgress: boolean;

}



export enum AddressType {
  Both = 'X',
  Shipping = 'S',
  Billing = 'B'
}



//#endregion
//#region CustomerAddress
export interface ICustomerAddress {
  id: string;
  isSelected?: boolean;
  shipTo: string;
  billTo: string;
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipcode: string;
  country?: string;
}
export class CustomerAddress implements ICustomerAddress {
  constructor() {
    this.isSelected = false;
  }
  billTo: string;
  id: string;
  isSelected = false;
  shipTo: string;
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipcode: string;
  country?: string;
}
//#endregion

//#region Item


export interface IItemSuggestion {
  itemNumber: string;
  fullDescription: string;
  itemType: number;
}

export interface IExtrusion {
  value: string;
  basePrice: number;
}
export interface IItemList {
  itemNumber: string;
  shortDescription: string;
  imageUrl: string;
  itemType: number;
  availableFinish: Array<IFinish>;
  qty: number;
  selectedFinishValue: string;
  selectedFinish: string;
  selectedFinishDescription: string;
  selectedSize: string;
  finishForServiceX: string;
  paints: string[];
  basePrice: number;
  listPrice: number;
  categoryId: number;
}


export interface ISearchItemResultPageResource {
  currentPage: number;
  totalRecords: number;
  currentPageData: Array<IItemList>;
}
export interface IItemSuggestion {
  itemNumber: string;
  fullDescription: string;
  itemType: number;
}
export class ItemSuggestion implements IItemSuggestion {
  itemNumber: string;
  fullDescription: string;
  itemType: number;
  constructor() {
    this.itemNumber = '';
    this.fullDescription = '';
    this.itemType = 1;
  }
}
export interface IGetItemSuggestionsBody {
  categoryId: number;
  searchstring: string;
}
export class GetItemSuggestionsBody implements IGetItemSuggestionsBody {
  categoryId: number;
  searchstring: string;
}
export interface IGetItemListBody {//to be deleted  
  searchQuery: string;
  itemNumber: string;
  longItemNumber: string;
  skip: number;
  take: number;
  pageNo: number;
  finishFilter: number[];
  categoryFilter: number[];
  sort: SortDescriptor[];
  filter: {}[];
}
export interface IFilterItemRequest {
  customerNumber: string;
  searchQuery: string;
  itemNumber: string;
  longItemNumber: string;
  skip: number;
  take: number;
  pageNo: number;
  finishFilter: string[];
  categoryFilter: number[];
  sort: SortDescriptor[];
  filter: {}[];
}
export class FilterItemRequest implements IFilterItemRequest {
  customerNumber: string;
  searchQuery: string;
  itemNumber: string;
  longItemNumber: string;
  skip: number;
  take: number;
  pageNo: number;
  finishFilter: string[];
  categoryFilter: number[];
  sort: SortDescriptor[];
  filter: {}[];
  constructor() {
    this.finishFilter = [];
    this.categoryFilter = [];
  }
}
export interface ISearchItemResultPageResource {
  currentPage: number;
  totalRecords: number;
  currentPageData: Array<IItemList>;
}
export class SearchItemResultPageResource
  implements ISearchItemResultPageResource {
  currentPage: number;
  totalRecords: number;
  currentPageData: ItemList[];
  categoryList: string[];
  finishList: string[];
}
//export interface IItemList {
//  itemNumber: string;
//  shortDescription: string;
//  imageUrl: string;
//  itemType: number;
//  availableFinish: Array<IFinish>;
//  qty: number;
//  selectedFinishValue: string;
//  selectedFinishDescription: string;
//  selectedSize: string;
//  finishForServiceX: string;


//}
export class ItemList implements IItemList {
  itemNumber: string;
  shortDescription: string;
  imageUrl: string;
  itemType: number;
  availableFinish: Finish[];
  qty = 1;
  selectedFinishValue: string;
  selectedFinishDescription: string;
  selectedSize: string;
  finishForServiceX: string;
  paints: string[];
  categoryId: number;
  selectedFinish: string;
  basePrice: number;
  listPrice: number;
  listPriceFormated: number = 0;
  constructor() {
    this.qty = 1;
  }
}
export interface IExtrusion {
  value: string;
  basePrice: number;
  listPrice: number;
}
export class Extrusion implements IExtrusion {
  value: string;
  basePrice: number; // would be decimal
  listPrice: number;
}
export interface IFinish {
  checked?: boolean;
  name: string;
  value: string;
  v6Code?: string;
  availableSizes: Array<IExtrusion>;
  eurrentExtrusionLength: IExtrusion;
  basePrice: number;
  listPrice: number;
}
export class Finish implements IFinish {
  checked?: boolean;
  name: string;
  value: string;
  v6Code?: string;
  availableSizes: Extrusion[];
  eurrentExtrusionLength: Extrusion;
  basePrice: number;
  listPrice: number;
  constructor() {
    this.checked = true;
    this.name = '';
    this.value = '';
    this.v6Code = '';
    this.availableSizes = [];
    this.eurrentExtrusionLength = null;
  }
}


export interface IMasterData {
  name: string;
  value: string;
  checked?: boolean;
}
export class MasterData implements IMasterData {
  name: string;
  value: string;
  checked?: boolean;
  public constructor() {
    this.checked = true;
  }
}

export class CheckboxMaster implements IMasterData {
  public constructor() {
    this.checked = true;
  }
  name: string;
  value: string;
  checked: boolean;
}

export interface IItemSearchCriteria {
  itemNumber: string;
  searchQuery: string;
  categoryId: number;
  allCategoryIds: number[];
}
export class ItemSearchCritera implements IItemSearchCriteria {
  itemNumber: string;
  searchQuery: string;
  categoryId: number;
  allCategoryIds: number[];
  constructor() {
    this.categoryId = -1;
    this.itemNumber = '';
    this.searchQuery = '';
    this.allCategoryIds = [];
  }
}
//#endregion

//#region User
export interface ICookieObject {
  domain: string;
  expires: number | Date;
  hasKeys: boolean;
  httpOnly: boolean;
  name: string;
  path: string;
  sameSite: 'Lax' | 'None' | 'Strict';
  secure: boolean;
  shareable: boolean;
  value: string;
}
export class CookieObject implements ICookieObject {
  domain: string;
  expires: number | Date;
  hasKeys: boolean;
  httpOnly: boolean;
  name: string;
  path: string;
  sameSite: 'Lax' | 'None' | 'Strict';
  secure: boolean;
  shareable: boolean;
  value: string;

}
export interface IUser {
  myCartItemCount: number | 0;
  customerName: string;
  customerNumber: string;
  roles: string[];
  mscData: string[];
  isCSCAccount: boolean;
  userName: string;
  userFirstName: string;
  password: string;
  userLastName: string;
  phoneNumber: string;
  faxNumber: string;
  userId: string;
  isInAdminRole: boolean;
  hasAccountSummary: boolean;
  hasInvoiceInquiry: boolean;
  isInvoicePayment: boolean;
  state: string;
  zipCode: string;
  addressLine1: string;
  city: string;
  email: string;
  hasManageAddress: boolean;
  isMSCAccount: boolean;
  canPlaceOrder: boolean;
  isActive: boolean;
  isApproved: boolean;
  lockCount: boolean;
  effectiveFrom: string;
  effectiveTo: string;
  userLanguage: string;
  lastTermsAndConditionAccepted: boolean;
  forceTermsAndCondition: boolean;
  defaultCustomer: [];
  mscCustomer: [];
  invalidLoginCount: number;
  forcePasswordReset: boolean;
  isValid: boolean;
  message: string;
  defaultShippingAddressNumber: number;
  billingStreet1Address: string;
  billingStreet2Address: string;
  billingCity: string;
  billingState: string;
  billingCounty: string;
  billingCountry: string;
  billingZipCode: string;
  billingPhoneNumber: number;
  requireAccountSummary: boolean;
  requireInvoiceDetails: boolean;
  userEnteredCustomerName: string;
  userEnteredCustomerNumber: string;
  contact: string;
  addedBy: string;
  lastLogin: string;
  dateAdded: Date;
  //userDetails: IUser;
  //userDetails: IUser;
  paymentTerms: string;
  currencyCode: string;
  userEmail: string;
}
export class User implements IUser {
  customerNumber: string;
  userId: string;
  customerName: string;
  roles: string[];
  isCSCAccount: boolean;
  isMSCAccount: boolean;
  userName: string;
  myCartItemCount: number | 0;
  email: string;
  mscData: string[];
  userLanguage: string;
  dateAdded: Date;
  lastLogin: string;
  userEmail: string;

  constructor() {
    this.customerName = '';
    this.customerNumber = '';
    this.roles = [];
    this.mscData = [];
    this.isCSCAccount = false;
    this.isMSCAccount = false;
    this.userName = '';
    this.myCartItemCount = 0;
    this.userFirstName = '';
    this.userLastName = '';
    this.email = '';
    this.userLanguage = 'eng';
    this.lastTermsAndConditionAccepted = false;
    this.forceTermsAndCondition = false;
  }
  sendTempPW: boolean;
  canPlaceOrder: boolean;
  isActive: boolean;
  isApproved: boolean;
  lockCount: boolean;
  effectiveFrom: string;
  effectiveTo: string;
  state: string;
  zipCode: string;
  addressLine1: string;
  city: string;
  isInAdminRole: boolean;
  hasAccountSummary: boolean;
  hasInvoiceInquiry: boolean;
  isInvoicePayment: boolean;
  hasManageAddress: boolean;
  userFirstName: string;
  password: string;
  userLastName: string;
  phoneNumber: string;
  faxNumber: string;
  lastTermsAndConditionAccepted: boolean;
  forceTermsAndCondition: boolean;
  defaultCustomer: [];
  mscCustomer: [];
  invalidLoginCount: number;
  forcePasswordReset: boolean;
  isValid: boolean;
  message: string;
  defaultShippingAddressNumber: number;
  billingStreet1Address: string;
  billingStreet2Address: string;
  billingCity: string;
  billingState: string;
  billingCounty: string;
  billingCountry: string;
  billingZipCode: string;
  billingPhoneNumber: number;
  requireAccountSummary: boolean;
  requireInvoiceDetails: boolean;
  userEnteredCustomerName: string;
  userEnteredCustomerNumber: string;
  adminNote: string;
  addedBy: string;
  contact: string;
  //userDetails: IUser;
  paymentTerms: string;
  currencyCode: string;
}

export interface IUserLogin {
  userDetails: IUser;
  isValid: boolean;
  message: string;
}
export interface ILoginRequest {
  username: string;
  password: string;
}
export class LoginRequest implements ILoginRequest {
  username: string;
  password: string;

}
export interface IPWALoginRequest {
  userName: string;
  deviceName: string;
  deviceWidth: string;
  deviceHight: string
}
export class PWALoginRequest implements IPWALoginRequest {
  userName: string;
  deviceName: string;
  deviceWidth: string;
  deviceHight: string
}
//#endregion


//#region BuildPak Admin


export interface IProductAttributesGetByattributeIdBody {
  attributeIds: string;//"attributeIds":"104,13,145"   
}
export interface IProductAttribute {
  attributeId: number
  attributeName: string;
  v6OptionCode: string;
  attributeValueTypeName: string;
  attributeValueTypeId: number;
  valuesFromV6: string;
  publishedName: string;
  isActive: boolean;
  attributeValues: Array<IAttributeValue>;
}

export class ProductAttribute implements IProductAttribute {
  attributeValues: IAttributeValue[];
  attributeId: number;
  attributeName: string;
  v6OptionCode: string;
  attributeValueTypeId: number;
  valuesFromV6: string;
  publishedName: string;
  isActive: boolean;
  constructor() {
    this.attributeId = 0;
    this.attributeName = '';
    this.v6OptionCode = '';
    this.publishedName = '';
    this.attributeValueTypeId = 0;
    this.valuesFromV6 = '';
    this.isActive = false;
    this.attributeValues = new Array<AttributeValue>();

  }
  attributeValueTypeName: string;
}
export interface IAttributeValue {
  attributeId: number;
  attributeValueId: number
  attributeValueName: string;
  attributeValueDescription: string;
  v6OptionCode: string;
  displaySequence: number;
  valuesFromV6: string;
  v6Code: string;
  isActive: boolean;
}

export class AttributeValue implements IAttributeValue {
  attributeId: number;
  attributeValueId: number;
  attributeValueName: string;
  attributeValueDescription: string;
  v6OptionCode: string;
  displaySequence: number;
  valuesFromV6: string;
  v6Code: string;
  isActive: boolean;
  constructor() {
    this.attributeId = 0;
    this.attributeValueId = 0;
    this.attributeValueName = '';
    this.attributeValueDescription = '';
    this.v6OptionCode = '';
    this.displaySequence = 0;
    this.valuesFromV6 = '';
    this.v6Code = '';
    this.isActive = false;

  }

}



//#endregion

//#region Cart
export interface ICartLbl {
  quickAddLbl: string;
  idDescriptionLbl: string;
  finishLbl: string;
  setDefaultLbl: string;
  defaultLbl: string;
  paintLbl: string;
  sizeLbl: string;
  quantityLbl: string;
  uomLbl: string;
  addToCartLbl: string;
  clearSelectionLbl: string;
  lineLbl: string;
  unitLbl: string;
  itemLbl: string;
  extrusionLbl: string;
  descriptionLbl: string;
  listPriceLbl: string;
  multiplierLbl: string;
  unitPriceLbl: string;
  extendedPriceLbl: string;
  quoteNameLbl: string;
  totalPriceLbl: string;
  importLbl: string;
  addToQuoteLbl: string;
  emptyCartLbl: string;
  ProceedToCheckoutLbl: string;
  clickLbl: string;
  uploadLbl: string;
  importSuccessMessageLbl: string;
  importSuccessMessageLbl1: string;
  errorMessage: string;
  addedToCartSuccessLbl: string;
  cartUpdatedLbl: string;
  confirmLbl: string;
  deleteConfirmLbl: string;
  deleteYesLbl: string;
  deleteNoLbl: string;
  confirmCartDelete: string;
  copyLbl: string;
  editLbl: string;
}
export interface ICartItemResponse {
  modifiedCartItems: any[];
  cartItemCount: number;
  statusMessage: string;
}

export interface ICartItem {
  userId: string;
  cartItemCommonId: string;
  itemNumber: string;
  longItemNumber: string;
  finishValue: string;
  v6FinishCode: string;
  finish: string;
  quantity: number;
  size: string;
  basePrice: number;
  cmp: number;
  listPrice: number;
  unitPrice: number;
  extendedPrice: number;
  quoteCommonId: string;
  jobName: string;
  paint: string;
  paints: string[];
  availableFinishes: Array<IFinish>;
  currentSizes: Extrusion[];
  customerNumber: string;
  categoryId: number;
  itemType: number;
  itemDescription: string;
  isValid: boolean;
  cartItemIdToRemove: string;
  productId: string;
  productCode: string;
  configProductCode: string;
  configProductId: number;
  isEmptyPaint: boolean;
  pushPullFinish: string;
  thumbnail: any;
}

export class CartItem implements ICartItem {
  itemType: number;
  itemDescription: string;
  quoteCommonId: string;
  jobName: string;
  userId: string;
  cartItemCommonId: string;
  itemNumber: string;
  longItemNumber: string;
  finishValue: string;
  finish: string;
  v6FinishCode: string;
  quantity: number;
  size: string;
  basePrice: number;
  cmp: number;
  listPrice: number;
  unitPrice: number;
  extendedPrice: number;
  availableFinishes: Array<IFinish>;
  currentSizes: Extrusion[];
  customerNumber: string;
  paint: string;
  paintName: string;
  paints: string[];
  categoryId: number;
  isValid: boolean;
  productId: string;
  productCode: string;
  cartItemIdToRemove: string;
  configProductCode: string;
  configProductId: number;
  isEmptyPaint: boolean;
  thumbnail: any;
  constructor() {
    this.isValid = true;
  }
  pushPullFinish: string;
}

export interface IImportExcelUpload {
  uploadSaveUrl: string;
  uploadRemoveUrl: string;
  show: boolean;
  toggleText: string;
  myRestrictions: FileRestrictions;
  userImages: Array<FileInfo>;
  showInfo: boolean;
}
export interface IImportItemFromExcel {
  itemNumber: string;
  itemQuantity: string;
  paintNumber: string;
}
export class ImportItemFromExcel implements IImportItemFromExcel {
  itemNumber: string;
  itemQuantity: string;
  paintNumber: string;
}

//#endregion
//#region import
export interface IImportLbl {
  uploadItemToExcelLbl: string;
  excelFileUploadLbl: string;
  importContentLbl1: string;
  importContentLbl2: string;
  importContentLbl3: string;
  importContentLbl4: string;
  importContentLbl5: string;
  importContentLbl6: string;
  importContentLbl7: string;
  importContentLbl8: string;
  importContentLbl9: string;
  importContentLbl10: string;
  importContentLbl11: string;
  importContentLbl12: string;
  importContentLbl13: string;
  importContentLbl14: string;
  clickLbl: string;
  uploadLbl: string;
}
//#endregion
//#region CheckOut
export interface IShipping {
  shippingAddres: ICustomer;
  billingAddress: ICustomer;
}
export interface IOrderDetail {
  jobName: string;
  jobCity: string;
  jobState: IState;
  po: string;
  marketSegment: IMasterData;
  freightTerms: IMasterData;
  requestDate: Date;
  confirmEmail: string;
  leed: boolean;
  taxable: string;
  quotedInHouse: boolean;
  quoteNumber: string;
  freightNotes: string;
  comments: string;
  inputTax: string;
  taxableCertification: string;
  useCreditCard: boolean;
  promoCodeCheck: boolean;
  promoCode: string;
  // myFiles: Array<FileInfo>;
  taxFile: string;
  taxFileName: string;
}

export class OrderDetail implements IOrderDetail {
  jobName: string;
  jobCity: string;
  jobState: IState;
  po: string;
  marketSegment: IMasterData;
  freightTerms: IMasterData;
  requestDate: Date;
  confirmEmail: string;
  leed: boolean;
  taxable: string;
  quotedInHouse: boolean;
  quoteNumber: string;
  freightNotes: string;
  comments: string;
  inputTax: string;
  taxableCertification: string;
  useCreditCard: boolean;
  promoCodeCheck: boolean;
  promoCode: string;
  // myFiles: Array<FileInfo>;
  taxFile: string;
  taxFileName: string;

}
export interface ICheckOutResponse {
  kdReferenceNumber: string;
}
export interface ICheckOutProcessModel {
  userId: string;
  customerNumber: string;
  // shipping
  // orderdetails
  // cart
  currentShipping: ICustomer;
  currentBilling: ICustomer;
  orderDetail: IOrderDetail;
  cartId: string;
  // temp variables
  shipToCustomerNumber: number;
  billToCustomerNumber: number;
  orderTotal: number;
}

export class CheckOutProcessModel implements ICheckOutProcessModel {
  userId: string;
  customerNumber: string;
  // shipping
  // orderdetails
  // cart
  currentShipping: ICustomer;
  currentBilling: ICustomer;
  orderDetail: IOrderDetail;
  cartId: string;
  // temp variables
  shipToCustomerNumber: number;
  billToCustomerNumber: number;
  orderTotal: number;

  constructor() {
    this.userId = "";
    this.customerNumber = "";
    this.orderDetail = new OrderDetail();
    this.cartId = "";
    // this.shipToCustomerNumber = "";
    // this.billToCustomerNumber = "";
  }
}


export interface IOrderDetailsFormValidate {
  isSubmitted: boolean;
  isInvalidJobName: boolean;
  isInvalidJobCity: boolean;
  isInvalidJobState: boolean;
  isInvalidTaxableCertification: boolean;
  isInvalidPO: boolean;
  isInvalidMyFiles: boolean;
  isInvalidMarketSegment: boolean;
  isInvalidFreightTerms: boolean;
  isInvalidQuoteNumber: boolean;
  isInvalidRequestDate: boolean;
  isInvalidFreightNotes: boolean;
  isInvalidConfirmEmail: boolean;
  isInvalidComments: boolean;
}
export class OrderDetailsFormValidate implements IOrderDetailsFormValidate {
  isSubmitted: boolean;
  isInvalidJobName: boolean;
  isInvalidJobCity: boolean;
  isInvalidJobState: boolean;
  isInvalidTaxableCertification: boolean;
  isInvalidPO: boolean;
  isInvalidMyFiles: boolean;
  isInvalidMarketSegment: boolean;
  isInvalidFreightTerms: boolean;
  isInvalidQuoteNumber: boolean;
  isInvalidRequestDate: boolean;
  isInvalidFreightNotes: boolean;
  isInvalidConfirmEmail: boolean;
  isInvalidComments: boolean;

}
export interface ICustomerAddressLabel {
  addAddressLbl: string;
  customerNumberLbl: string;
  nameLbl: string;
  addressLine1Lbl: string;
  addressLine2Lbl: string;
  cityLbl: string;
  stateLbl: string;
  zipcodeLbl: string;
  countryLbl: string;
  countyLbl: string;
  phoneNumberLbl: string;
  phoneValidationLbl: string;
  archiveLbl: string;
  closeLbl: string;
  saveLbl: string;
  selectAddressLbl: string;
  shippingAddressLbl: string;
  duplicateAddressText1: string;
  duplicateAddressText2: string;
  duplicateAddressText3: string;
  addNewAddressLbl: string;
  selectLbl: string;

}
export interface ICustomerShipTo {
  id: number;
  billTo: string;
  shipTo: string;
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  phoneNumber: string;
}

export interface ICheckOutLabel {
  checkoutPageTitle: string;
  currentBillingAddressLbl: string;
  currentShippingAddressLbl: string;
  krnLbl: string;
  missingFields: string;
  orderConfirmLbl: string;
  orderDetailsLbl: string;
  paymentLbl: string;
  reviewOrderLbl: string;
  shippingLbl: string;
  submitedInfo1: string;
  submitedInfo2: string;
  submitedInfo3: string;
  submitedInfo4: string;
  continueLbl: string;
  confirmOrderLbl: string;
  thanksLbl: string;
  continueShoppingLbl: string;
  kawneerOrderLbl: string;
  kdLbl: string;
  closeLbl: string;
  surveyFeedbackLbl: string;
}
export interface ICheckOutOrderDetailsLbl {
  commentsLbl1: string;
  commentsLbl2: string;
  confirmEmailLbl: string;
  frieghtTermsLbl: string;
  frightNotesLbl: string;
  inputTax: string;
  jobCityLbl: string;
  jobNameLbl: string;
  jobStateLbl: string;
  leedLbl: string;
  marketSegmentLbl: string;
  poLbl: string;
  quotedInHouseLbl: string;
  quoteNumberLbl: string;
  requestDateLbl: string;
  requiredFieldLbl: string;
  taxableCertificationLbl: string;
  taxableLbl: string;
  characterRemainingLbl: string;
  promoCodeLbl: string;
  promoApplyLbl: string;
  promoNotValidLbl: string;
  promoValidLbl: string;
  defaultCreditInfoLbl: string;
  toModifyCreditLbl: string;
  payByCreditLbl: string;
  cardTypeLbl: string;
  nameOnCardLbl: string;
  creditCardNumberLbl: string;
  cardExpiryLbl: string;

}
export interface IcheckoutOrderDetails {
  jobName: string;
  jobCity: string;
  jobState: IDropDownData;
  po: string;
  marketSegment: IDropDownData;
  freightTerms: IDropDownData;
  requestDate: Date;
  confirmEmail: string;
  leed: boolean;
  taxable: boolean;
  quotedInHouse: boolean;
  quoteNumber: string;
  freightNotes: string;
  comments: string;
  inputTax: string;
  taxableCertification: string;
  myFiles: Array<FileInfo>;
  promoCodeCheck: boolean;
  promoCode: string;
}
export interface ICartReviewsLbl {
  finishLbl: string;
  paintLbl: string;
  sizeLbl: string;
  quantityLbl: string;
  uomLbl: string;
  lineLbl: string;
  unitLbl: string;
  itemLbl: string;
  extrusionLbl: string;
  descriptionLbl: string;
  listPriceLbl: string;
  multiplierLbl: string;
  unitPriceLbl: string;
  extendedPriceLbl: string;
  quoteNameLbl: string;
  totalPriceLbl: string;
}
export interface IDropDownData {
  text: string;
  value: string;
}

export interface IGetAllSupportDataForCheckOutOrderDetail {
  countries: Array<ICountry>;
  marketSegments: Array<MasterData>;
  freightTerms: Array<MasterData>;
}
export class CheckOutDetail implements IGetAllSupportDataForCheckOutOrderDetail {
  countries: Array<ICountry>;
  marketSegments: Array<MasterData>;
  freightTerms: Array<MasterData>;
}

//#endregion

//#region Change Customer
export interface IChangeCustomer {
  customerNumber: string;
  customerName: string;
  customerNameToDisplay: string;
}
export class ChangeCustomer implements IChangeCustomer {
  customerNumber: string;
  customerName: string;
  searchQuery: string;
  customerNameToDisplay: string;
  public constructor() {
    this.customerNumber = '';
    this.searchQuery = '';
  }
}
export interface IChangeCustomerBody {
  searchstring: string;
}
//#endregion
//#region Credit Card
export interface ICreditCardDetails {
  isSavedAsDefault: boolean
  cardNumber: string
  expirationDate: string;
  nameOnCard: string;
  cardType: string;
  expirationYear: string;
  expirationMonth: string;
}
export class CreditCardDetails implements ICreditCardDetails {
  isSavedAsDefault: boolean
  cardNumber: string
  expirationDate: string;
  nameOnCard: string;
  cardType: string;
  expirationYear: string;
  expirationMonth: string;

}
export interface ICreditInfoBody {
  customerNumber: string
}
export class CreditInfoBody implements ICreditInfoBody {
  customerNumber: string;

}
//#endregion
//#region Job name search
export interface IJobNameSearch {
  customerNumber: string;
  userName: string;
  jobNumber: string;
  jobName: string;
  city: string;
  state: string;
}
export class JobNameSearch implements IJobNameSearch {
  customerNumber: string;
  userName: string;
  jobNumber: string;
  jobName: string;
  city: string;
  state: string;
}
export interface IJobSearch {
  customerNumber: string
  jobNumber: string;
  jobName: string;
  city: string;
  state: string;
  isSelected: boolean
}
export class JobSearch implements IJobSearch {
  customerNumber: string; jobNumber: string;
  jobName: string;
  city: string;
  state: string;
  isSelected: boolean;

}
//#endregion

//#region manage user account
export interface IUpdateUserBody {
  userName: string;
  userFirstName: string;
  userLastName: string;
  email: string;
}
export interface IUpdateUserAccessToScreensBody {
  userId: string;
  hasInvoiceInquiry: boolean;
  hasAccountSummary: boolean;
  hasManageAddress: boolean;
  canPlaceOrder: boolean;
  isInAdminRole: boolean;
  isActive: boolean;
}


export interface IUserAccount {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  isInvoiceInquiry: boolean;
  isAccountSummary: boolean;
  isManageAddress: boolean;
  canPlaceOrder: boolean;
  admin: string;
  lastLogin: string;
}
export class UserAccount implements IUserAccount {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  isInvoiceInquiry: boolean;
  isAccountSummary: boolean;
  isManageAddress: boolean;
  canPlaceOrder: boolean;
  admin: string;
  lastLogin: string;
}

export interface INewUserBody {
  userId: string;
  userName: string;
  userFirstName: string;
  userLastName: string;
  customerNumber: string;
  email: string;
  confirmEmail: string;
  companyName: string;
  companyAccountNumber: string;
  billingAddress1: string;
  billingAddress2: string;
  city: string;
  county: string;
  state: string;
  country: string;
  zipCode: string;
}
export interface INewUserLabel {
  pageTitleLbl: string;
  userNameLbl: string;
  passwordLbl: string;
  firstNameLbl: string;
  lastNameLbl: string;
  emailLbl: string;
  confirmEmailLbl: string;
  phoneNumberLbl: string;
  companyNameLbl: string;
  companyAccNumberLbl: string;
  invalidEmailLbl: string;
  confirmEmailMatchLbl: string;
  registerLbl: string;
  resetLbl: string;
  userNotAvailableLbl: string;
  invalidPhoneLbl: string;
  successMsgLbl: string;
  errorMsgLbl: string;
}
export interface INewUserSaveLabel {
  successMsgLbl: string;
  errorMsgLbl: string;
}
//#region customer multiplier
export interface IMultiplier {
  itemGroup: string;
  itemGroupDescription: string;
  itemGroupMultiplier: string;
}
export class Multiplier implements IMultiplier {
  itemGroup: string;
  itemGroupDescription: string;
  itemGroupMultiplier: string;
}
export interface IMultiplierPlan {
  customerAddress: ICustomer;
  multiplierPlans: IMultiplier[];
}
export interface IMultiplierPlanLabel {
  customerNumberLbl: string;
  territoryCodeLbl: string;
  multiplierLbl1: string;
  multiplierLbl2: string;
  dateText: string;
  multiplierLbl3: string;
  multiplierLbl4: string;
  multiplierLbl5: string;
  itemGroupLbl: string;
  descriptionLbl: string;
  itemGroupMultiplierLbl: string;
  exportToPdfLbl: string;
  exportToExcelLbl: string;
  headingLbl: string;
  footarTextLbl: string;
}
//endregion
//#region sample request

export interface ISampleRequestLabel {
  categoryLbl: string;
  imageLbl: string;
  finishCategoryLbl: string;
  productLbl: string;
  genderLbl: string;
  sizeLbl: string;
  quantityLbl: string;
  addSelectionBtnLbl: string;
  companyNameLbl: string;
  addressLine1Lbl: string;
  jobNameLbl: string;
  addressLine2Lbl: string;
  phoneNumberLbl: string;
  cityLbl: string;
  stateLbl: string;
  zipCodeLbl: string;
  info1Lbl: string;
  sampleSelectionLbl: string;
  selectionLbl: string;
  continueLbl: string;
  reviewSelectionLbl: string;
  shippingDetailsLbl: string;
  phoneNumberValidationLbl: string;
  cancelLbl: string;
  placeOrderLbl: string;
  submitResponseLbl: string;
  contactFirstNameLbl: string;
  contactLastNameLbl: string;
}
export interface ISampleRequestBody {
  finishCategory: string;
  finish: string;
  quantity: number;
}
export interface ISize {
  name: string;
  value: string;
}
export interface IGender {
  name: string;
  value: string;
}

export interface ISampleRequestGrid1 {
  image: string;
  finishCategory: string;
  finish: string;
  size: Array<ISize>;
  gender: Array<IGender>;
  quantity: number;
  finishSampleLevel1key: string;
  r_VALUE: string;
  g_VALUE: string;
  b_VALUE: string;
  externalImage: string;
  skuNo: string;
}
export class SampleRequestGrid1 implements ISampleRequestGrid1 {
  image: string;
  finishCategory: string;
  finish: string;
  size: Array<ISize>;
  gender: Array<IGender>;
  quantity: number = 1;
  finishSampleLevel1key: string;
  r_VALUE: string;
  g_VALUE: string;
  b_VALUE: string;
  externalImage: string;
  skuNo: string;
  constructor() {
    this.quantity = 1;
  }
}
export interface ISampleRequest {
  image: string;
  finishSampleLevel1key: string;
  finishCategory: string;
  finish: string;
  finishCode: string;
  size: string;
  gender: string;
  quantity: number;
  r_VALUE: string;
  g_VALUE: string;
  b_VALUE: string;
  externalImage: string;
  skuNo: string;
}
export class SampleRequest implements ISampleRequest {
  image: string;
  finishSampleLevel1key: string;
  finishCategory: string;
  finish: string;
  finishCode: string;
  size: string;
  gender: string;
  quantity: number;
  r_VALUE: string;
  g_VALUE: string;
  b_VALUE: string;
  externalImage: string;
  skuNo: string;

}
export interface IFinishCategory {
  finishSampleLevel1key: number;
  category: string;
  displayOrder: number;
  userType: string;
}
export interface ISampleCategoryBody {
  finishSampleLevel1key: number;
  category: string;
}

//#Region Sample Product fulfillment
export interface ISampleSubCategory {
  subCategoryId: number;
  categoryId: number;
  categoryName: string;
  sku: number;
  subCategoryDescription: string;
  maxQtyCanBeOrdered: number;
  ec: string;
  colorCode: string;
  stockNum: string;
  currentCostId: number;
  stockingLevel: number;
  currentInventory: number;
  reorderPoint: number;
  r_VALUE: string;
  b_VALUE: string;
  g_VALUE: string;
  imagePath: string;
  displayOrder: number;
  isActive: boolean;
  isActiveCategory: boolean,
  isVisibleToOnlyPDMTeam: boolean;
  isVisibleToExternalUser: boolean;
  onBackOrder: boolean;
  absoluteURL: string;
  width: number;
  length: number;
  height: number,
  weight: number;
  size: string;
}

export interface ISampleCategory {
  categoryId: number;
  categoryName: string;
}

export interface ISampleSubCategoryRequestGrid1 {
  quantity: number;
  externalImage: string;
  subCategoryId: number;
  categoryId: number;
  categoryName: string;
  sku: number;
  subCategoryDescription: string;
  maxQtyCanBeOrdered: number;
  ec: string;
  colorCode: string;
  stockNum: string;
  currentCostId: number;
  stockingLevel: number;
  currentInventory: number;
  reorderPoint: number;
  r_VALUE: string;
  b_VALUE: string;
  g_VALUE: string;
  imagePath: string;
  displayOrder: number;
  isActive: boolean;
  isActiveCategory: boolean,
  isVisibleToOnlyPDMTeam: boolean;
  isVisibleToExternalUser: boolean;
  onBackOrder: boolean;
  absoluteURL: string;
  width: number;
  length: number;
  height: number,
  weight: number;
  size: string;
}
export class SampleSubCategoryRequestGrid1 implements ISampleSubCategoryRequestGrid1 {
  quantity: number;
  externalImage: string;
  subCategoryId: number;
  categoryId: number;
  categoryName: string;
  sku: number;
  subCategoryDescription: string;
  maxQtyCanBeOrdered: number;
  ec: string;
  colorCode: string;
  stockNum: string;
  currentCostId: number;
  stockingLevel: number;
  currentInventory: number;
  reorderPoint: number;
  r_VALUE: string;
  b_VALUE: string;
  g_VALUE: string;
  imagePath: string;
  displayOrder: number;
  isActive: boolean;
  isActiveCategory: boolean;
  isVisibleToOnlyPDMTeam: boolean;
  isVisibleToExternalUser: boolean;
  onBackOrder: boolean;
  absoluteURL: string;
  width: number;
  length: number;
  height: number;
  weight: number;
  size: string;
  constructor() {
    this.quantity = 1;
  }
}

export interface ISampleProductDetailItems {
  quantity: number;
  externalImage: string;
  subCategoryId: number;
  categoryId: number;
  categoryName: string;
  sku: number;
  subCategoryDescription: string;
  maxQtyCanBeOrdered: number;
  ec: string;
  colorCode: string;
  stockNum: string;
  currentCostId: number;
  stockingLevel: number;
  currentInventory: number;
  reorderPoint: number;
  size: string;
  r_VALUE: string;
  b_VALUE: string;
  g_VALUE: string;
  imagePath: string;
  displayOrder: number;
  isActive: boolean;
  isActiveCategory: boolean,
  isVisibleToOnlyPDMTeam: boolean;
  isVisibleToExternalUser: boolean;
  onBackOrder: boolean;
  absoluteURL: string;
}
export interface ISampleRegion {
  regionCode: string;
  regionDescription: string;
}
export class SampleRegion {
  regionCode: string;
  regionDescription: string;
}
export interface ISamplePlaceOrderBody {
  sampleRequestItems: Array<ISampleProductDetailItems>,
  companyName: string,
  jobName: string,
  addressLine1: string,
  addressLine2: string,
  phoneNumber: number,
  city: string,
  state: string,
  zipCode: string,
  customerNumber: string;
  languageCode: string;
  //userId: string;
  stateCode: string;
  contactFirstName: string;
  contactLastName: string;
  country: string;
  ccEmail: string;
  region: string;
}
export interface IGetSampleProductOrderHeader {
  startDate: Date;
  endDate: Date;
}
export interface IGetSampleProductOrderDetailsByHeader {
  sampleProductUniqueId: number;
}
export interface IGetSampleSubCategoryCostBySubcategoryId {
  subCategoryId: number;
}
export interface IGetFilterSampleReorderReport {
  onlyReorders: boolean,
  inActiveReorders: boolean;
}
export interface IGetFilterSampleUsageReport {
  startDate: Date;
  endDate: Date;
  region: string;
  isActive: boolean;
}
export interface IGetFilterSampleBudgetReport {
  startDate: Date;
  endDate: Date;
}
export interface ISampleUsageReport {
  id: number,
  subCategoryId: number;
  categoryId: number;
  categoryName: string;
  subCategoryDescription: string;
  stockNum: string;
  totalCost: number;
  totalQuantity: number;
  region: string;
  totalOrders: string;
  orderCost: number;
  isActive: boolean;
  
}
export interface ISampleReorderReport {
  subCategoryId: number;
  categoryId: number;
  categoryName: string;
  subCategoryDescription: string;
  stockNum: string;
  currentCostId: number;
  stockingLevel: number;
  currentInventory: number;
  reorderPoint: number;
  isActive: boolean;
  isReorder: string;
  avgUsagePerMonth: string;
  noOfMonths: string;
}
export interface ISampleAdminBudget {
  budget: number;
  cost: number;
}
export interface ISampleSubCategoryExist {
  stockNumber: string;
  subCategoryId: number;
}
export interface ISampleAdminBudgetAllocation {
  regionCode: string;
  regionDescription: string;
  budgetCode: string;
}
export interface ISampleSubCategoryCost {
  subCategoryId: number;
  subCategoryDescription: string;
  cost: string,
  effectiveFrom: Date,
  effectiveTo: Date,
  isCurrentCost: boolean
}
export interface ISampleProductOrderHeader {
  id: number,
  sampleProductRequestHeaderId: string,
  firstName: string,
  lastName: string,
  customerNumber: string,
  companyName: string,  
  ccEmail: string;
  region: string;
  createdDate: Date,
  createdDateUIString: string,
  sampleProductOrderNumber: string,
  cost: string,
  contact: string,
  customer: string,
}
export interface ISampleProductOrderDetails {
  sampleProductRequestHeaderId: string,
  categoryId: number,
  subCategoryId: number,
  categoryName: string,
  subCategoryDescription: string,
  colorCode: string,
  stockNum: string,
  quantity: string;
  createdDate: Date,
  sampleProductOrderNumber: string,
  cost: string,
  sampleProductUniqueId: number
}
// #End Region Sample Product fulfillment

export interface ISampleFinish {
  subCategoryId: number;
  finishSampleLevel1key: number;
  sku: number;
  finishCode: string;
  finish: string;
  maxQty: number;
  displayOrder: number;
  finishCategory: string;
  userType: string;
  isActive: boolean;
  gender: string;
  size: string;
  absoluteURL: string;
  relativeURL: string;
  r_VALUE: string;
  b_VALUE: string;
  g_VALUE: string;
}
export interface IPlaceOrderBody {
  sampleRequestItems: Array<ISampleRequest>,
  companyName: string,
  jobName: string,
  addressLine1: string,
  addressLine2: string,
  phoneNumber: string,
  city: string,
  state: string,
  zipCode: string,
  customerNumber: string;
  languageCode: string;
  //userId: string;
  stateCode: string;
  contactFirstName: string;
  contactLastName: string;
}
//#endregion
//#endregion
//#region Common Grid Model
// export GridState: State = {
//  sort: [
//    {
//      field: 'itemNumber',
//      dir: 'asc',
//    },
//  ],
//  skip: 0,
//  take: 10,
//  group: [],
//  // filter: {},
// };
//#endregion

//#region Submittal Package---Need refactor
export interface ISubmittalPackageDetail {
  category: string;
  selectedValues: Array<any>;
  multiSelectData: Array<ISubmittalPackageLevel2>
}
export interface ISubmittalPackageLevel2 {
  submittalLevel2key: string;
  submittalLevel1key: string;
  subCategory: string;
  displayOrder: string;
  urlPath: string;
}
export interface IProductTypeBody {
  subCategory: string;
  submittalLevel2key: string;
}

export interface ITestReportCategory {
  submittalLevel3key: string;
  testReportCategory: string;
  displayOrder: string;
  reportNumber: string;
  subCategoryDisplayOrder: string;
  submittalLevel2key: string;
  submittalLevel4key: string;
  testReportSubCategory: string;
  testType: string;
  testTypeDisplayOrder: string;
  urlPath: string;
  productOptTested: string;
}

export interface ICategoryBody {
  testReportCategory: string;
  submittalLevel3key: string;
}
export interface ITestReportSubCategory {
  submittalLevel4key: string;
  testReportSubCategory: string;
}

export interface ISubCategoryBody {
  testReportSubCategory: string;
  submittalLevel4key: string;
}
export interface ITestReportType {
  submittalLevel4key: string;
  testType: string;
}


export interface ITestReportData {
  submittalLevel3key: string;
  testReportCategory: string;
  displayOrder: string;
  reportNumber: string;
  subCategoryDisplayOrder: string;
  submittalLevel2key: string;
  submittalLevel4key: string;
  testReportSubCategory: string;
  testType: string;
  testTypeDisplayOrder: string;
  urlPath: string;
  productOptTested: string;
}

export interface IDownloadSubmittal {
  projectName: string;
  projectLocation: string;
  aluminiumCare: boolean;
  architectureDetails: boolean;
  customerVarificationLetter: boolean;
  preSubmittalDocument: boolean;
  sampleWarranty: Array<ISampleWarranty>;
  testReport: boolean;
  glassDocument: Array<GlassDocument>;
  paintDocument: Array<PaintDocument>;
  architectureDetailsData: Array<ISubmittalPackageLevel2>;
  testReportData: Array<ITestReportData>;
  companyContactName: string;
  requestedBy: string;
  customerName: string;
  customerNumber: string;
  userName: string;
  userLanguage: string;
  leedPreSubmittalDocument: Array<ILeedMultiSelect>;
  productDeclare: Array<ILeedMultiSelect>;
  environmentalProduct: Array<ILeedMultiSelect>;
  cradle: Array<ILeedMultiSelect>;
  materialTransparency: Array<ILeedMultiSelect>;
}
export interface ILeedMultiSelect {
  name: string;
  value: number;
}
export interface ISampleWarranty {
  name: string;
  value: number;
}
export interface GlassDocument {
  name: string;
  value: number;
}
export interface PaintDocument {
  name: string;
  value: number;
}

export interface ISubmittalLbl {
  selectionsPanelLbl: string;
  projectNameLbl: string;
  projectLocationLbl: string;
  aluminumCareLbl: string;
  architecturalDetailsLbl: string;
  architecturalDetailsTitleLbl: string;
  customerVerficationLetterLbl: string;
  leedPreSubmittalDocumentationLbl: string;
  sampleWarrantiesLbl: string;
  testReportsLbl: string;
  glassDocumentsLbl: string;
  paintDocumentsLbl: string;
  testReportsPanelLbl: string;
  productTypeLbl: string;//add
  selectTestReportCategoryLbl: string;
  selectTestReportSubCategoryLbl: string;
  testTypeLbl: string; //add
  addTestReportLbl: string; //add
  testReportNoLbl: string; //add
  testReportDescLbl: string; //add
  continueLbl: string;
  companyContactNameLbl: string;
  kanweerTermsConditionsLbl: string;
  termsAndConditionsPart1: string;
  termsConditionsLbl: string;
  downloadSubmittalLbl: string;
  cancelLbl: string;

}

//#endregion
//#region CustomTermsAndConditionsNotes
export interface ICustomTermsAndConditionsNotes {
  description: string;
  createdBy: string;
  createdDate: Date;
  udatedBy: string;
  featureName: string;
  customTermsAndConditionsId: number;
}
export class CustomTermsAndConditionsNotes implements ICustomTermsAndConditionsNotes {
  description: string;
  createdBy: string;
  createdDate: Date;
  featureName: string;
  udatedBy: string;
  customTermsAndConditionsId: number;
}



export interface IAccountSummary {
  amountDue: string;
  totalExposure: string;
  overCreditLimit: string;
  lastInvoiceDate: string;
  paymentTerms: string;
  openOrderAmount: string;
  creditLimit: string;
  dateOfFirstInvoice: string;
  dateLastPaid: string;

}


export class AccountSummary implements IAccountSummary {
  amountDue: string;
  totalExposure: string;
  overCreditLimit: string;
  lastInvoiceDate: string;
  paymentTerms: string;
  openOrderAmount: string;
  creditLimit: string;
  dateOfFirstInvoice: string;
  dateLastPaid: string;
}
export interface IAccountSummaryLabel {
  amountDueLbl: string;
  billingAddressLbl: string;
  creditLmtLbl: string;
  dateLastPaidLbl: string;
  dofInvoiceLbl: string;
  lastInvoiceDateLbl: string;
  openOrderAmtLbl: string;
  pageTitle: string;
  overCreditLmtLbl: string;
  paymentTermsLbl: string;
  totalExposureLbl: string;
}
//#endregion
//#region credit reference
export interface ICreditReferenceBody {
  customerNumber: string;
  email: string;
}
export interface ICreditReferenceLabel {
  acceptTermsLbl: string;
  emailLbl: string;
  confirmEmailLbl: string;
  creditRefTermsAndConditionsLbl: string;
  pageTitle: string;
  submitLbl: string;
  cancelLbl: string;
  termsAndConditionsPartOne: string;
  invalidEmailLbl: string;
  confirmEmailMatchLbl: string;
  creditRefRequestInfoLbl: string;
  emailAddressAtRequestLbl: string;
}
//#endregion
//#region Generate warranty
export interface IGetRelatedServiceOrderBody {
  customerNumber: string;
  orderNumber: string;
}
export interface IGenerateWarranty {
  serviceOrderNumber: number;
  orderBu: string;
  jobName: string;
  jobNumber: string;
  orderDate: string;
  workmanship: string;
  finishedWarranty: string;
  scheduleDate: string;
  orderDateUIString: string;
  scheduleDateUIString: string;
  poNumber: string;
  shipFrom: string;
  shipTo: string;
  billTo: string;
  orderDateAsDate: Date;
  scheduleDateAsDate: Date;
}
export interface IGetGenerateWarrantyBody {
  customerNumber: string;
  fromDate: Date;
  toDate: Date;
  isFrench: boolean;
}
export interface IGenerateWarrantyLabel {
  finishWarrantyLbl: string;
  jobNameLbl: string;
  jobNumberLbl: string;
  kdRefLbl: string;
  materialWorkmanshipLbl: string;
  orderDateLbl: string;
  pageTitle: string;
  purchaseOrderLbl: string;
  relatedSOsLbl: string;
  serviceOrderLbl: string;
  shipFromLbl: string;
  orderTypeLbl: string;
  poLbl: string;
  scheduleDateLbl: string;
  downloadWarrantyLbl: string;
  relatedServiceLbl: string;
  exportToPdfLbl: string;
  exportToExcelLbl: string;
}
//#endregion
//#region lien release
export interface IDownLoadLienRelease {
  invoiceNumber: string;
  lienType: string;
  progressLienThruDate: string;
  notary: string;
  faxNumber: string;
  paidType: string;
  paidAmount: string;
  customerNumber: string;
}
export interface InvoiceNumberBody {
  invoiceNumber: string;
  customerNumber: string;
  date: string;
}
export interface ILienReleaseLabel {
  acceptTermsAndConditionsLbl: string;
  businessDaysToProcessLbl: string;
  cancelButtonLbl: string;
  faxLbl: string;
  invoiceNumberLbl: string;
  lienReleaseLbl: string;
  lienReleaseTermsAndConditionsLbl: string;
  lienReleaseTermsAndConditionsTex1tLbl: string;
  lienReleaseTermsAndConditionsTex2tLbl: string;
  lienReleaseTermsAndConditionsTex3tLbl: string;
  notaryRequiredLbl: string;
  selectLienTypeLbl: string;
  submitButtonLbl: string;
  progressLienThruDateLbl: string;
  continueLbl: string;
  invalidInvoiceNumberLbl: string;
  paidDefaultLbl: string;
  paidByKawneerLbl: string;
  paidByCustomerLbl: string;
  noSelectionTextLbl: string;
  continueDownloadLbl: string;
  invoiceDetailTitleLbl: string;
  downoadTitleLbl: string;

}
//#endregion
//#region Language Translation
export interface ILanguageTranslation {
  componentName: string;
  languageCode: string;
  controlName: string;
  controlText: string;
  isUpdated: boolean;
}
export interface IControlNameBody {
  controlTextList: Array<ILanguageTranslation>;
}

export interface ILanguages {
  languageCode: string;
  languageText: string;
  imageControlName: string;
}
//#endregion
//#region marketing admin- Submittal package admin
export interface IArchitectureCategory {
  categoryId: string;
  categoryDescription: string;
  IsCategoryActive: boolean;
}
export interface IArchitectureCategoryBody {
  categoryId: string;
  categoryDescription: string;
  IsCategoryActive: boolean;
}
export interface IArchitectureDetails {
  categoryId: string;
  categoryDescription: string;
  subCategoryId: string;
  subCategoryDescription: string;
  urlPath: string;
  isActive: boolean;

}
export interface IArchitectureDetailsBody {
  categoryId: string;
  categoryDescription: string;
  subCategoryId: string;
  subCategoryDescription: string;
  urlPath: string;
  isActive: boolean;
}
export interface ArchitectureDetails {
  categoryId: string;
  categoryDescription: string;
  subCategoryId: string;
  subCategoryDescription: string;
  urlPath: string;
  isActive: boolean;
}
export interface ICategoryData {
  categoryId: string;
  categoryDescription: string;
}
export interface ITestReportGrid {
  subCategoryId: string;
  subCategoryDescription: string;
  testCategoryId: string;
  testCategoryDescription: string;
  testSubCategoryId: string;
  testSubCategoryDescription: string;
  testType: string;
  testReportDescription: string;
  testReportNumber: string;
  ecNumber: string;
  ecVersion: string;
  urlPath: string;
  isActive: boolean;
  testReportId: number;

}
export interface ITestReportDropdownData {
  subCategoryId: string;
  subCategoryDescription: string;
  testCategoryId: string;
  testCategoryDescription: string;
  testSubCategoryId: string;
  testSubCategoryDescription: string;
  testType: string;
  testReportDescription: string;
  testReportNumber: string;
  ecNumber: string;
  ecVersion: string;
  urlPath: string;

}
export interface ITestReportDropdownData {
  subCategoryId: string;
  subCategoryDescription: string;
  testCategoryId: string;
  testCategoryDescription: string;
  testSubCategoryId: string;
  testSubCategoryDescription: string;
  testType: string;
  testReportDescription: string;
  testReportNumber: string;
  ecNumber: string;
  ecVersion: string;
  urlPath: string;
  isActive: boolean;
  testReportId: number;
}
export interface ITestReportBody {
  subCategoryId: string;
  subCategoryDescription: string;
  testCategoryId: string;
  testCategoryDescription: string;
  testSubCategoryId: string;
  testSubCategoryDescription: string;
  testType: string;
  testReportDescription: string;
  testReportNumber: string;
  ecNumber: string;
  ecVersion: string;
  urlPath: string;
  isActive: boolean;
  testReportId: number;
}
export interface IArchitectureSubCategoryBody {
  subCategoryId: string;
  architectureSubCategoryDescription: string;
  isArchitectureSubCategoryActive: boolean;
}
export interface ITestCategoryBody {
  testCategoryId: string;
  subCategoryId: string;
  subCategoryDescription: string;
  testCategoryDescription: string;
  testSubCategoryId: string;
  testSubCategoryDescription: string;
  testType: string;
  testReportDescription: string;
  testReportNumber: string;
  ecNumber: string;
  ecVersion: string;
  urlPath: string;
  isActive: boolean;
  testReportId: number;
}

export interface ITestCategoryData {
  testCategoryId: string;
  testCategoryDescription: string;
}

export interface ITestSubCategoryData {
  testSubCategoryId: string;
  testSubCategoryDescription: string;
}
//#endregion
//#region marketing admin- Sample Finish Admin
export interface IAddSampleFinishCategoryBody {
  subCategoryId: number;
  finishSampleLevel1key: number;
  sku: number;
  finishCode: string;
  finish: string;
  maxQty: number;
  displayOrder: number;
  finishCategory: string;
  userType: string;
  isActive: boolean;
  gender: string;
  size: string;
  // urlPath: string;
  relativeURL: string;
  absoluteURL: string;
  r_VALUE: string;
  b_VALUE: string;
  g_VALUE: string;
  //category: string;
  //userType: string;
  //userId: string;
  //isActive: boolean;
}
//export interface IAddSampleFinishSubCategoryBody {
//  finishSampleLevel1key: number;
//  sku: number;
//  finishCode: string;
//  finish: string;
//  maxQty: number;
//  userId: string;
//  isActive: boolean;
//}


export interface ISampleFinishCategory {
  finishSampleLevel1key: number;
  finishCategory: string;

}

//#endregion




//#region IBaseResponse
export interface IBaseResponse {
  data: Array<any>;
  errorMessage: string;
  isError: boolean;
}
export class BaseResponse implements IBaseResponse {
  data: Array<any>;
  errorMessage: string;
  isError: boolean;
}
//#endregion


//#region IBaseResponse
export interface ITransalation {
  kdText: string;
  v6Text: string;
  field: string;
}
export class Transalation implements ITransalation {
  kdText: string;
  v6Text: string;
  field: string;
  constructor() {
    this.field = '';
    this.kdText = '';
    this.v6Text = '';
  }

}
//#endregion

//#region IMacro

export interface IGetProductDependencies {
  attributes: IBuildPakAttribute[];
  macros: IMacro[];
}
export interface IMacrosByIdBody {
  ids: string; ////"ids":"104,13,145"
}
export interface IMacro {
  id: number;
  name: string;
  description: string;
  target: string;
  type: string;
  isActive: boolean;
  expression: string;
  oldExpression: string;
  userId: string;
  selectedType: IMasterData;
  selectedtarget: IMasterData;
}
export class Macro implements IMacro {
  id: number;
  name: string;
  description: string;
  target: string;
  type: string;
  isActive: boolean;
  expression: string;
  oldExpression: string;
  userId: string;
  selectedType: IMasterData;
  selectedtarget: IMasterData;
}
//#endregion
//#Bp1 config V6 options
export interface IBp1configurationRequest {
  customerCode: string;// "1000",
  reference: string;// "ProdRef123",
  originalDescription: string;// "190/350/500 Standard Entrance - Single or Pair 3 Door Openings",
  quantity: number;// 1.0,
  defaultOptions: IV6DefaultOption[];
  outerFrame: IV6outerFrameBp1;
}
export class Bp1configurationRequest implements IBp1configurationRequest {
  customerCode: string;// "1000",
  reference: string;// "ProdRef123",
  originalDescription: string;// "190/350/500 Standard Entrance - Single or Pair 3 Door Openings",
  quantity: number;// 1.0,
  defaultOptions: IV6DefaultOption[];
  outerFrame: IV6outerFrameBp1;
  constructor() {
    this.customerCode = '';
    this.reference = '';
    this.originalDescription = '';
    this.quantity = 1;
    this.defaultOptions = new Array<V6DefaultOption>();
    this.outerFrame = new V6outerFrameBp1();
  }
}

export interface IV6DefaultOption {
  code: string;//"Job/Exterior Finish",
  value: string;//"[COL:K:14 (14)]
}
export class V6DefaultOption implements IV6DefaultOption {
  code: string;//"Job/Exterior Finish",
  value: string;//"[COL:K:14 (14)]
  constructor() {
    this.code = '';
    this.value = '';
  }
}
export interface IV6NestedFrame {
  frameCode: string;// "[FRA:A2:SBVMORT]",
  frameOptions: IV6DefaultOption[];
}
export class V6NestedFrame implements IV6NestedFrame {
  frameCode: string;// "[FRA:A2:SBVMORT]",
  frameOptions: IV6DefaultOption[];

  constructor() {
    this.frameCode = '';
    this.frameOptions = new Array<V6DefaultOption>();
  }
}
export interface IV6outerFrameBp1 {
  nestedFrames: IV6NestedFrame[];
  frameCode: string;//": "[FRA: A2: TF3DO]",
  frameOptions: IV6DefaultOption[];
}
export class V6outerFrameBp1 implements IV6outerFrameBp1 {
  nestedFrames: IV6NestedFrame[];
  frameCode: string;//": "[FRA: A2: TF3DO]",
  frameOptions: IV6DefaultOption[];

  constructor() {
    this.nestedFrames = new Array<V6NestedFrame>();
    this.frameOptions = new Array<V6DefaultOption>();
    this.frameCode = '';
  }
}

//#endregion
//#Bp2 config V6 options
export interface IBp2ConfigurationRequest {
  configuration: IV6configuration;
  outerFrame: IV6outerFrame;
  messages: any[];
}
export class Bp2ConfigurationRequest implements IBp2ConfigurationRequest {
  configuration: IV6configuration;
  outerFrame: IV6outerFrame;
  messages: any[];
  fills: IV6Fill[];
  constructor() {
    this.messages = [];
    this.configuration = new V6configuration();
    this.outerFrame = new V6outerFrame();
    this.fills = [];
  }
}

export interface IV6Fill {
  quantity: number;
  width: string;
  height: string;
  thickness: string;
}

export class V6Fill implements IV6Fill {
  quantity: number;
  width: string;
  height: string;
  thickness: string;
}


export interface IV6configuration {

  status: string;
  dateCreated: string;
  originalItemId: string;
  v6QuoteNumber: string;//"0"
  originalDescription: string;
  reference: string;
  customerCode: string;
  quoteItemCommonId: string;
  quoteCommonId: string;
  v6ItemSequenceNumber: string;//0
  unitNetSellPrice: string;//null
  unitGrossSellPrice: string;//null
  quantity: number;//1.0
  concessionedQuoteCopyCommonId: string;//null
  concessionedQuoteItemCopyCommonId: string;//null
}
export class V6configuration implements IV6configuration {

  status: string;
  dateCreated: string;
  originalItemId: string;
  v6QuoteNumber: string;//"0"
  originalDescription: string;
  reference: string;
  customerCode: string;
  quoteItemCommonId: string;
  quoteCommonId: string;
  v6ItemSequenceNumber: string;//0
  unitNetSellPrice: string;//null
  unitGrossSellPrice: string;//null
  quantity: number;//1.0
  concessionedQuoteCopyCommonId: string;//null
  concessionedQuoteItemCopyCommonId: string;//null

  constructor() {
    this.status = '';
    this.dateCreated = '';
    this.originalItemId = '';
    this.v6QuoteNumber = '';
    this.originalDescription = '';
    this.reference = '';
    this.customerCode = '';
    this.quoteItemCommonId = '';
    this.quoteCommonId = '';
    this.concessionedQuoteItemCopyCommonId = '';
    this.concessionedQuoteItemCopyCommonId = '';
    this.v6ItemSequenceNumber = '0';
    this.unitNetSellPrice = '0';
    this.unitGrossSellPrice = '0';
    this.quantity = 0;
  }
}

export interface IV6outerFrame {
  quoteWideFrameId: string;//null
  nestedFrames: IV6nestedFrame[];//null
  options: IV6option[];//null    
  frameOptions: V6option[];//null

}
export class V6outerFrame implements IV6outerFrame {

  options: IV6option[];//null
  nestedFrames: IV6nestedFrame[];//null
  quoteWideFrameId: string;//null
  frameOptions: V6option[];//null

  constructor() {
    this.nestedFrames = [];
    this.quoteWideFrameId = '';
    this.options = [];
    this.frameOptions = [];
  }

}
export interface IV6option {
  valueType: string;// null,
  v6ValueType: string;// null,
  listValues: IV6listValue[];// null,
  isResourceAttribute: boolean;// false,
  isPublished: boolean;//false,
  isReported: boolean;// false,
  key: string;// null,
  listCode: string;// null,
  code: string;// "EFINISH1",
  value: string;// "[COL:K:14 (14)]"
}
export class V6option implements IV6option {
  valueType: string;// null,
  v6ValueType: string;// null,
  listValues: IV6listValue[];// null,
  isResourceAttribute: boolean;// false,
  isPublished: boolean;//false,
  isReported: boolean;// false,
  key: string;// null,
  listCode: string;// null,
  code: string;// "EFINISH1",
  value: string;// "[COL:K:14 (14)]"

  constructor() {
    this.isResourceAttribute = false;
    this.isPublished = false;
    this.isReported = false;
    this.valueType = '';
    this.v6ValueType = '';
    this.key = '';
    this.listCode = '';
    this.code = '';
    this.value = '';
    this.listValues = new Array<V6listValue>();
  }
}

export interface IV6nestedFrame {
  quoteWideFrameId: string;// "{985F4E81-B808-43FC-9B8C-CABD7D52D3CC}_{F93CF248-DF6C-4011-8F87-3E47C29A6C67}",
  frameOptions: IV6frameOption[];
}
export class V6nestedFrame implements IV6nestedFrame {
  quoteWideFrameId: string;// "{985F4E81-B808-43FC-9B8C-CABD7D52D3CC}_{F93CF248-DF6C-4011-8F87-3E47C29A6C67}",
  frameOptions: IV6frameOption[];
  constructor() {
    this.quoteWideFrameId = '';
    this.frameOptions = new Array<V6frameOption>();
  }
}

export interface IV6frameOption {
  valueType: string;// "Double",
  v6ValueType: string;// "",
  listValues: IV6listValue[];// [],
  isResourceAttribute: boolean;// false,
  isPublished: boolean;// false,
  isReported: boolean;// false,
  key: string;// "Width",
  listCode: string;// "",
  code: string;// "",
  value: string;// "35 13/16\""
}
export class V6frameOption implements IV6frameOption {
  valueType: string;// "Double",
  v6ValueType: string;// "",
  listValues: IV6listValue[];// [],
  isResourceAttribute: boolean;// false,
  isPublished: boolean;// false,
  isReported: boolean;// false,
  key: string;// "Width",
  listCode: string;// "",
  code: string;// "",
  value: string;// "35 13/16\""

  constructor() {
    this.valueType = '';
    this.v6ValueType = '';
    this.isResourceAttribute = false;
    this.isPublished = false;
    this.isReported = false;
    this.code = '';
    this.key = '';
    this.listCode = '';
    this.value = '';
    this.listValues = new Array<V6listValue>();
  }
}
export interface IV6listValue {
  code: string;// "AL",
  description: string;// "Aluminum",
  displayText: string;// null
}
export class V6listValue implements IV6listValue {
  code: string;// "AL",
  description: string;// "Aluminum",
  displayText: string;// null
  constructor() {
    this.code = '';
    this.description = '';
    this.displayText = '';
  }
}


//#endregion

//#region Product Configuration
export interface IGetProductDependenciesBody {
  attributeIds: string;
  macroIds: string;
}
export interface IGetProductDetailsBody {
  id: number;
  attributeIds: string;
  macroIds: string;
  itemId: string;
  //loadProductDetails: boolean;
  //loadMacroDetails: boolean;
  //loadAttributeDetails: boolean;

}
export interface IGetKwikkeyProductDetailsBody {
  productCode: string;
  itemId: string;
}
export interface IV6PreviewModel {
  configuration: IV6configuration;
  outerFrame: IV6outerFrame;
}
export class V6PreviewModel implements IV6PreviewModel {
  configuration: IV6configuration;
  outerFrame: IV6outerFrame;
}
export interface IV6PreviewBaseConfig {
  computedName: string;
  productName: string;
  productCode: string;
  productDescription: string;
}
export interface IProductTemplate {
  fills: IV6Fill[];
  translationFamily: string;
  type: V6ProductType;
  computedName: string;
  productName: string;
  productCode: string;
  productId: string;
  productDescription: string;
  bypassBaseConfig: boolean;
  quantity: number;
  reference: string;
  configNameExpression: IMacro;
  productAttributes: IBuildPakAttribute[];
  bp1Macros: IMacro[];
  bp2Macros: IMacro[];
  confirmMacros: IMacro[];
  resourceFrame: IFrameTemplate;
  nestedFrames: IFrameTemplate[];
  //these fields we might add later if required
  //Nested Frames Header BP1
  //Nested Frames Header BP2
  //Nested Frames Header Confirm
  //Nested Frames Name
  status: string;
  dateCreated: string;
  originalItemId: string;
  v6QuoteNumber: string;
  originalDescription: string;
  customerCode: string;
  quoteItemCommonId: string;
  quoteCommonId: string;
  v6ItemSequenceNumber: string;
  unitNetSellPrice: string;
  unitGrossSellPrice: string;
  concessionedQuoteCopyCommonId: string;
  concessionedQuoteItemCopyCommonId: string;
  nestedFrameForUI: any[];
  erros: string[];
  kwikKeyProductSeries: string;
  kwikKeyOptionCode: string;
  kwikKeyFinish: string;
  kwikKeyV6Finish: string;
  kwikKeyOptionCodeSuffix: string;
  v6SummaryMessage: any[];
  kkConfigType: KwikKeyConfigType;
  pushPullFinish: string;
}
export class ProductTemplate implements IProductTemplate {
  fills: IV6Fill[];
  translationFamily: string;
  type: V6ProductType;
  computedName: string;
  productName: string;
  productCode: string;
  productId: string;
  productDescription: string;
  bypassBaseConfig: boolean;
  configNameExpression: IMacro;
  productAttributes: IBuildPakAttribute[];
  bp1Macros: IMacro[];
  bp2Macros: IMacro[];
  confirmMacros: IMacro[];
  resourceFrame: IFrameTemplate;
  nestedFrames: IFrameTemplate[];
  quantity: number;
  reference: string;
  status: string;
  dateCreated: string;
  originalItemId: string;
  v6QuoteNumber: string;
  originalDescription: string;
  customerCode: string;
  quoteItemCommonId: string;
  quoteCommonId: string;
  v6ItemSequenceNumber: string;
  unitNetSellPrice: string;
  unitGrossSellPrice: string;
  concessionedQuoteCopyCommonId: string;
  concessionedQuoteItemCopyCommonId: string;
  nestedFrameForUI: any[];
  erros: string[];
  kwikKeyProductSeries: string;
  kwikKeyOptionCode: string;
  kwikKeyOptionCodeSuffix: string;
  kwikKeyFinish: string;
  kwikKeyV6Finish: string;
  v6SummaryMessage: any[];
  kkConfigType: KwikKeyConfigType;
  pushPullFinish: string;
  constructor() {
    this.resourceFrame = new FrameTemplate();
    this.nestedFrames = [];
    this.productAttributes = [];
    this.bp1Macros = [];
    this.bp2Macros = [];
    this.confirmMacros = [];
    this.nestedFrameForUI = [];
    this.type = V6ProductType.CONFIGURED;
    this.bypassBaseConfig = false;
    this.quantity = 1;
    this.erros = [];
    this.v6SummaryMessage = [];
    this.reference = "";
    this.fills = [];
    this.kkConfigType = KwikKeyConfigType.NONE;
  }
}
export interface IProductTemplateError {
  productAttributeError: string[];
  resourceFrameError: string[];
  nestedFrameError: [];

}
export class ProductTemplateError implements IProductTemplateError {
  productAttributeError: string[];
  resourceFrameError: string[];
  nestedFrameError: [];
  constructor() {
    this.productAttributeError = [];
    this.resourceFrameError = [];
    this.nestedFrameError = [];
  }
}
export interface IFrameTemplate {
  frameAdditionalText: string;
  frameConfig: string;
  quoteWideFrameId: string;
  frameName: string;
  framecodePrefix: string;
  haveFrameCode: boolean;
  frameCode: string;
  haveAttributeFilter: boolean;
  attributeFilters: IBuildPakAttribute[];
  attributeFiltersForUI: any[];
  framecodeSuffix: string;
  type: V6FrameType;//1 for resource frame, 2 for nested frame
  frameConfigType: V6FrameConfigType;
  clicked: boolean;
  isError: boolean;
  erros: string[];
  //options
}
export class FrameTemplate implements IFrameTemplate {
  frameAdditionalText: string;
  frameConfig: string;
  quoteWideFrameId: string;
  frameName: string;
  framecodePrefix: string;
  haveFrameCode: boolean;
  frameCode: string;
  haveAttributeFilter: boolean;
  attributeFilters: IBuildPakAttribute[];
  attributeFiltersForUI: any[];
  framecodeSuffix: string;
  type: V6FrameType;
  frameConfigType: V6FrameConfigType;
  clicked: boolean;
  isError: boolean;
  erros: string[];
  constructor() {
    this.attributeFilters = [];
    this.attributeFiltersForUI = [];
    this.frameAdditionalText = '';
    this.frameConfig = '';
    this.quoteWideFrameId = '';
    this.frameName = '';
    this.framecodePrefix = '';
    this.haveFrameCode = false;
    this.frameCode = '';
    this.frameConfig = '';
    this.erros = [];
    this.clicked = false;
    this.isError = false;
  }
}
//#endregion


//#region error List

export interface IErrorList {
  id: string,
  message: string,
  exception: string,
  logger: string,
  dateAdded: string

}

export class ErrorList implements IErrorList {
  id: string;
  message: string;
  exception: string;
  logger: string;
  dateAdded: string;
}

//#endregion

//#region Promocode

export interface IPromocodes {
  PromoCodeId: string,
  PromoCode: string,
  PromoCodeDescription: string,

}

//#endregion

//#region Broadcast Message
export interface IBroadcastMessage {
  messageId: number;
  message: string;
  dateAdded: string;
  messageAddedById: string;
  messageAddedBy: string;
  isActive: boolean;
}
export interface IBroadcastMessageBody {
  message: string;
  //messageAddedById: string;
  isActive: boolean;
}
//#endregion
//#region Promo Code
export interface IPromoCode {
  promoCodeId: string;
  promoCode: string;
  promoCodeDescription: string;
  startDate: string;
  endDate: string;
  minPrice: string;
  maxPrice: string;
  productType: string;
  region: string;
  terittory: string;
  customer: string;
  isActive: boolean;
}
export interface IPromoCodeBody {
  promoCodeId: string;
  promoCode: string;
  promoCodeDescription: string;
  startDate: string;
  endDate: string;
  minPrice: string;
  maxPrice: string;
  productType: string;
  region: string;
  terittory: string;
  customer: string;
  isActive: boolean;
}

//#endregion
//#region Outage Schedule
export interface IOutageSchedule {
  outageScheduleId: string;
  outageDescription: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  isActive: boolean;
}

export interface IOutageScheduleBody {
  outageScheduleId: string;
  outageDescription: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  isActive: boolean;
}
//#endregion
//#region Item Catalog
export interface IItemCatalog {
  id: number;
  jdeItemId: string;
  itemNumber: string;
  longItemNumber: string;
  shortDescription: string;
  fullDescription: string;
  size: string;
  description1: string
  finishValue: string;
  itemType: string;
  thumbNailPicture: string;
  actualPicture: string;
  basePrice: string;
  v6Price: string;
  priceBookCategoryDescription: string;
  priceBookCategoryId: number;
  description2: string,
  description3: string,
  canPlaceOrder: boolean,
  excludedInNightJob: boolean,
  isActive: boolean,
  effectiveFrom?: Date,
  effectiveTo?: Date,
  addedBy: string,
  additionalImage: string,
  excludedPriceUpdateInNightJob: boolean,
  manuallyAddedDonotTouch: boolean,
  v6FinishCode: string
}
export interface IItemCatalogBody {
  id: number;
  jdeItemId: string;
  itemNumber: string;
  longItemNumber: string;
  shortDescription: string;
  fullDescription: string;
  size: string;
  description1: string
  finishValue: string;
  itemType: number;
  thumbNailPicture: string;
  actualPicture: string;
  basePrice: string;
  priceBookCategoryDescription: string;
  priceBookCategoryId: number;
  description2: string,
  description3: string,
  canPlaceOrder: boolean,
  excludedInNightJob: boolean,
  isActive: boolean,
  effectiveFrom?: Date,
  effectiveTo?: Date,
  addedBy: string,
  additionalImage: string,
  excludedPriceUpdateInNightJob: boolean,
  associatedCategories: string,
  manuallyAddedDonotTouch: boolean,
  v6FinishCode: string
}
//#endregion

//#region Response model
export interface IApiResultResponse {
  isError: boolean;
  errorMessage: string;
  data: any;
}
//#endregion
export interface IFinishes {
  name: string;
  value: string;
  v6ReferenceValue: string;
}

//#region image admin
export interface IImageAdmin {
  imageId: boolean;
  applicationCode: string;
  languageCode: string;
  componentName: string;
  imageType: string;
  imageDescription: string;
  urlPath: string;
  isActive: boolean;
}
export interface IImageAdminBody {
  imageId: boolean;
  applicationCode: string;
  languageCode: string;
  componentName: string;
  imageType: string;
  imageDescription: string;
  urlPath: string;
  isActive: boolean;
}
//#endregion

//#region Home Page Banner 
export interface IBannerImageBody {
  languageCode: string;
}
//#endregion
//#region thermal calculator
export interface IThermalCalculatorLabel {
  selectionsPanelLbl: string;
  systemSelectionLbl: string;
  projectNameLbl: string;
  projectLocationLbl: string;
  productTypeLbl: string;
  productSeriesLbl: string;
  customerGlazingInfoLbl: string;
  ufactorLbl: string;
  solarHeatLbl: string;
  visibleTransmittanceLbl: string;
  testSizeLbl: string;
  projectSizeVisionLbl: string;
  projectSizeDimensionLbl: string;
  visibleAreaLbl: string;
  jobSpecificationLbl: string;
  jobSpecificationMsg: string;
  totalOfHorizontalLbl: string;
  totalOfVerticalLbl: string;
  continueLbl: string;
  termsConditionTitleLbl: string;
  termsConditionContentLbl: string;
  acceptTermsConditionLbl: string;
  calculateLbl: string;
  cancelLbl: string;
  coglbl: string;
  ngrcLbl: string;
  projectValueLbl: string;
  shgcLbl: string;
  vtLbl: string;
  visionAreaLbl: string;
  tableContent1Lbl: string;
  tableContent2Lbl: string;
  tableContent3Lbl: string;
  tableContent4Lbl: string;
  tableContent5Lbl: string;
  editLbl: string;
  downloadLbl: string;
}
export interface IProjectDimensionLabel {
  chooseLbl: string;
  ftLbl: string;
  inLbl: string;
  verticalDloLbl: string;
  horizontalDloLbl: string;
}
export interface IThermalCalculator {
  //projectName: string;
  //projectLocation: string;
  productType: string;
  productSeries: string;
  uFactor: string;
  solarHeatGainCoefficient: string;
  visibleTransmittance: string;
  sizeCategory: string;
  visionValue: boolean;
  totalHorizontals: number;
  totalVerticals: number;
  horizontalDLO: [];
  verticalDLO: [];
}
export interface IThermalCalculateData {
  nFRCSizeValues: string;
  cOGUFactor: string;
  cOGSolarHeatGainCoefficient: string;
  COGVisibleTransmittance: string;
  nFRCUFactor: string;
  nFRCSolarHeatGainCoefficient: string;
  nFRCVisibleTransmittance: string;
  projectValuesUFactor: string;
  projectValuesSolarHeatGainCoefficient: string;
  projectValuesVisibleTransmittance: string;
  nFRCVisionArea: string;
  projectValuesVisionArea: string;
  lawneerTestReportNFRC102: string;
  lawneerTestReportAMMA: string;
  kawneerTestReportNFRC: string;
  complianceCertificate: string;
}
//#endregion
//#region mechanics school

export interface IMechanicSchoolLabel {
  mechnicsSchoolInformationLbl: string;
  mechnicsSchoolLbl: string;
  locationInformationLbl: string;
  registrationLbl: string;
  onlineRegistrationLbl: string;
  firstNameLbl: string;
  lastNameLbl: string;
  jobTitleLbl: string;
  companyNameLbl: string;
  addressLbl: string;
  cityLbl: string;
  commentLbl: string;
  emailLbl: string;
  phoneNumber: string;
  faxNumberLbl: string;
  countryLbl: string;
  stateLbl: string;
  zipCodeLbl: string;
  selectSeminarLbl: string;
  continueLbl: string;
  submitLbl: string;
  cancelLbl: string;
  invalidEmail: string;
  infoLbl: string;
  priceLbl: string;
  invalidPhoneLbl: string;
}
export interface IMechanicSchoolAdminBody {
  id: number;
  mechanicsSchoolId: string;
  schoolDescription: string;
  languageCode: string;
  trainingName: string;
  trainingDescription: string;
  registrationDescription: string;
  mechanicsSchoolLocationDetails: ILocationInformation[];
  schoolDescriptionPdfUrlPath: string;
  registrationDescriptionPdfUrlPath: string;
}
export interface ILocationInformation {
  locationId: number;
  mechanicsSchoolId: string;
  locationName: string;
  locationDescription: string;
  price: number;
  startDate: string;
  endDate: string;
  totalSeats: number;
}
export interface IRegisterMechanicsLocationDetails {
  id: number;
  registrationId: string;
  locationId: string;
  isChecked: boolean;
}
//#endregion
//#region module school
export interface IModuleSchoolLabel {
  modulesSchoolInformationLbl: string;
  trainingModuleDescriptionLbl: string;
  moduleDescriptionLbl: string;
  registrationLbl: string;
  onlineRegistrationLbl: string;
  firstNameLbl: string;
  lastNameLbl: string;
  jobTitleLbl: string;
  companyNameLbl: string;
  addressLbl: string;
  cityLbl: string;
  commentLbl: string;
  emailLbl: string;
  phoneNumber: string;
  faxNumberLbl: string;
  countryLbl: string;
  stateLbl: string;
  zipCodeLbl: string;
  selectModuleLbl: string;
  continueLbl: string;
  submitLbl: string;
  cancelLbl: string;
  invalidEmail: string;
  moduleNote: string;
  onlineRegistrationNote: string;
  invalidPhoneLbl: string;
}
export interface IModulesSchoolBody {
  id: number;
  moduleSchoolId: string;
  trainingName: string;
  languageCode: string;
  trainingDescription: string;
  registrationDescription: string;
  moduleSchoolLocationDetails: IModulesLocationDetails[];
  modulesList: IModules[];
  registrationUrlPath: string;
  trainingUrlPath: string;
}
export interface IModulesLocationDetails {
  locationId: number;
  mechanicsSchoolId: string;
  locationName: string;
  locationDescription: string;
  startDate: string;
  endDate: string;
  totalSeats: number;
  modulesList: IModules[];
}
export interface IModules {
  ModuleName: string;
  ModuleShortDescription: string;
  ModuleDescription: string;
  StartDate: string;
  EndDate: string;
  price: number;

}
export interface IRegisterModulesList {
  id: number;
  registrationId: string;
  moduleId: string;
  isChecked: boolean;
}
//#endregion
//#region Literature module
export interface ILiteratureDocumentLabel {
  headingLbl: string;
  note1Lbl: string;
  note2Lbl: string;
}
export interface ILiteratureDocumentDetails {
  docGroupingAlias: string;
  firstcolumnLbl: string;
  secondcolumnLbl: string;
  thirdColumnLbl: string;
  isSecondColumnVisible: boolean;
  isThirdColumnVisible: boolean;
  //literatureDocumentCategory: any;
}

export interface IPdfDocument {
  docGroupingID: number;
  //languageCode: string;
  docGroupingAlias: string;
  docCategoryID: number;
  docCategoryDesc: string;
  backgroundColor: string;
  docSubCategoryID: number;
  docSubCategoryDesc: string;
  docDesc: string;
  partNo: string;
  pathName: string;
  revision: string;
}

export interface IParentPdfCollection extends IPdfDocument {
  // documentGroupingID: number;
  // languageCode: string;
  // documentGroupingAlias: string;
  // documentCategoryID: number;
  // documentCategoryDescription: string;
  // backgroundColor: string;
  // documentSubCategoryID: number;
  // documentSubCategoryDescription: string;
  // documentDescription: string;
  // partNo: string;
  // pathName: string;
  // revision: string;

  pdfCollection: IPdfDocument[];
}



export class PDFDocument implements IPdfDocument {


  docGroupingID: number;
  //languageCode: string;
  docGroupingAlias: string;
  docCategoryID: number;
  docCategoryDesc: string;
  backgroundColor: string;
  docSubCategoryID: number;
  docSubCategoryDesc: string;
  docDesc: string;
  partNo: string;
  pathName: string;
  revision: string;
}

export class ParentPdfCollection implements IParentPdfCollection {


  docGroupingID: number;
  //languageCode: string;
  docGroupingAlias: string;
  docCategoryID: number;
  docCategoryDesc: string;
  backgroundColor: string;
  docSubCategoryID: number;
  docSubCategoryDesc: string;
  docDesc: string;
  partNo: string;
  pathName: string;
  revision: string;
  pdfCollection: IPdfDocument[];
}
//#endregion
//#region survey
export interface ISurveyAdmin {
  surveyId: string;
  question: string;
}
export interface ISurveyDetails {
  surveyId: string;
  question: any;
  rating: string;
  surveyRating: ISurveyRatings[];
}
export interface ISurveyRatings {
  id: number;
  name: string;
  isSelected: boolean;
  label: string;
  checked: string;
}
//#endregion
//#region news
export interface INewsAdmin {
  backgroundColor: string;
  displayOrder: number;
  docCategoryDesc: string;
  docCategoryID: number;
  docDesc: string;
  docGroupingAlias: string;
  docGroupingID: number;
  docID: number;
  docSubCategoryDesc: string;
  docSubCategoryID: number;
  docTypeID: number;
  partNo: string;
  pathName: string;
  revision: string;
}

//#endregion 
//export class BannerImageBody implements IBannerImageBody
//{

//  languageCode: string;

//}
//#endregion
//#Region Product Mapping
export interface IPrductMapping {
  categoryId: number;
  categoryName: string;
  categoryImageUrl: string;
  subCategoryId: string;
  subCategoryName: string;
  subCategoryImageUrl: string
  configId: string;
  configName: string;
  configImageUrl: string;
  categoryDescription: string;
  isCategoryActive: boolean;
  subCategoryDescription: string;
  isSubCategoryActive: boolean;
  configDescription: string;
  isCofigActive: boolean;
  templateName: string;
  templateId: string;
  templateCode: string;
  languageCode: string;
  categoryLanguageCode: string;
  subCategoryLanguageCode: string;
  configLanguageCode: string;
  categoryUniqueID: number;
  subCategoryUniqueID: number;
  configUniqueID: number;
}
export interface IPrductCategory {
  id: number;
  name: string;
  imageUrl: string;
  description: string;
  isActive: boolean;
  categoryLanguageCode: string;
  categoryUniqueID: number;
}
export interface IPrductSubCategory {
  id: string;
  name: string;
  imageUrl: string;
  description: string;
  isActive: boolean;
  categoryName: string;
  categoryImageUrl: string;
  productCategoryId: number;
  subCategoryLanguageCode: string;
  subCategoryUniqueID: number;
}
export interface IPrductConfiguration {
  id: string;
  name: string;
  imageUrl: string;
  description: string;
  isActive: boolean;
  categoryId: number;
  categoryName: string;
  categoryImageUrl: string;
  productSubCategoryId: string;
  subCategoryName: string;
  subCategoryImageUrl: string
  productName: string;
  productId: string;
  productCode: string;
  configUniqueID: number;
}
export interface IPTempCodes { }
export interface IBBProductHierarchies {
  categories: IBBPrductCategory[];
  subCats: IBBProductSubCategory[];
  configs: IBBPrductConfiguration[];
  templateProductCodes: IPTempCodes[]
}

export interface IBBPrductCategory {
  //id: number;
  //name: string;
  //imageUrl: string;
  //description: string;

  //categoryLanguageCode: string;
  //categoryUniqueID: number;
  uniqueId: number;
  id: number;
  name: string;
  imageUrl: string;
  description: string;
  isActive: boolean;
  languageCode: string;
}
export class BBPrductCategory implements IBBPrductCategory {
  uniqueId: number;
  id: number;
  name: string;
  imageUrl: string;
  description: string;
  isActive: boolean;
  languageCode: string;
}
export interface IBBProductSubCategory {
  //id: string;
  //name: string;
  //imageUrl: string;
  //description: string;
  //isActive: boolean;
  //categoryName: string;
  //categoryImageUrl: string;
  //productCategoryId: number;
  //subCategoryLanguageCode: string;
  //subCategoryUniqueID: number;
  uniqueId: number;
  id: number;
  name: string;
  description: string;
  productImageUrl: string;
  productCategoryUniqueId: number;
  productCategoryName: string;
  productCategoryImageUrl: string;
  languageCode: string;
  isActive: boolean;

}
export class BBProductSubCategory implements IBBProductSubCategory {
  uniqueId: number;
  id: number;
  name: string;
  description: string;
  productImageUrl: string;
  productCategoryUniqueId: number;
  productCategoryName: string;
  productCategoryImageUrl: string;
  languageCode: string;
  isActive: boolean;
}
export interface IBBPrductConfiguration {
  //id: string;
  //name: string;
  //imageUrl: string;
  //description: string;
  //isActive: boolean;
  //categoryId: number;
  //categoryName: string;
  //categoryImageUrl: string;
  //productSubCategoryId: string;
  //subCategoryName: string;
  //subCategoryImageUrl: string
  //productName: string;
  //productId: string;
  //productCode: string;
  //configUniqueID: number;
  uniqueId: number;
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  subCatUniqueId: number;
  subCatName: string;
  subCatImageUrl: string;
  catName: string;
  catUniqueId: number;
  catImageUrl: string;
  productCode: string;
  productTemplateName: string;
  languageCode: string;
  isActive: boolean;
}
export class BBPrductConfiguration implements IBBPrductConfiguration {
  uniqueId: number;
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  subCatUniqueId: number;
  subCatName: string;
  subCatImageUrl: string;
  catName: string;
  catUniqueId: number;
  catImageUrl: string;
  productCode: string;
  productTemplateName: string;
  languageCode: string;
  isActive: boolean;
}
export class BBConfigModal extends BBPrductConfiguration {
  constructor() {
    super();
    this.catList = [];
    this.subCatList = [];
    this.selectedCat = new BBPrductCategory();
    this.selectedSubCat = new BBProductSubCategory();
    this.productTemplateList = [];
    this.selectedTemplate = new PTempCodes();
  }
  langList: any[];
  catList: IBBPrductCategory[];
  subCatList: IBBProductSubCategory[];
  selectedCat: IBBPrductCategory;
  selectedSubCat: IBBProductSubCategory;
  productTemplateList: IPTempCodes[];
  selectedTemplate: IPTempCodes;
}
export interface IPTempCodes {
  id: number;
  productCode: string;
}
export class PTempCodes implements IPTempCodes {
  id: number;
  productCode: string;
}


//#endregion
//#region footer pages
export interface ILegalNoticesLabel {
  headingLbl: string;
  subHeadingLbl: string;
  emailTextLbl: string;
  content1Lbl: string;
  content2Lbl: string;
  content3Lbl: string;
  content4Lbl: string;
  content5Lbl: string;
  content6Lbl: string;
  content7Lbl: string;
  content8Lbl: string;
  content9Lbl: string;
  content10Lbl: string;
  content11Lbl: string;
  content12Lbl: string;
  content13Lbl: string;
  content14Lbl: string;
}

export interface IFooterLabel {
  footerDisclosureLbl: string;
  contactUsLbl: string;
  FAQLbl: string;
  kawneerComLbl: string;
  legalNoticeLbl: string;
  privacyPolicyLbl: string;
  termsAndConditionsLbl: string;
  copyRightLbl: string;
  copyRightTxtLbl: string;
}

export interface IContactUSLabel {
  headingTextLbl: string;
  firstNameLbl: string;
  lastNameLbl: string;
  emailLbl: string;
  customerNumberLbl: string;
  commentsLbl: string;
  contactInfoLbl: string;
  phoneNumberLbl: string;
  invalidPhoneLbl: string;
  cancelLbl: string;
  saveLbl: string;
  invalidEmailLbl: string;
}
//#endregion
//#region menu
export interface ILeftSideMenuLabel {
  home: string;
  admin: string;
  orderManagement: string;
  invoiceInquiry: string;
  manageQuotes: string;
  orderInquiry: string;
  buildAndBuyLowercase: string;
  selfServiceUtilities: string;
  creditReference: string;
  generateWarranty: string;
  sampleRequest: string;
  submittalPackage: string;
  lienRelease: string;
  thermalCalculator: string;
  windowPricingToolLbl: string;
  literature: string;
  priceCatalog: string;
  installationAndCare: string;
  installationInstructions: string;
  installationVideoCurtainwall: string;
  cleaningAluminumFinishes: string;
  installationVideoStorefront: string;
  orderForms: string;
  correctiveFieldRepair: string;
  estimatingAndTakeoffGuides: string;
  certifications: string;
  videoTrainingLbl: string;
  training: string;
  customerSpecificSchool: string;
  mechanicsSchool: string;
  modulesSchool: string;
  partnerPakTraining: string;
  preInstallationSystemReview: string;
  newsLbl: string;
}
export interface ITaxCertificates {
  id: string;
  name: string;
}
//#endregion
//#region terms and condition
export interface ITermsConditionsLabel {
  termsContent1Lbl: string;
  termsContent2Lbl: string;
  termsContent3Lbl: string;
  termsContent4Lbl: string;
  termsContent5Lbl: string;
  termsContent6Lbl: string;
  termsContent7Lbl: string;
  termsContent8Lbl: string;
  termsContent9Lbl: string;
  termsContent10Lbl: string;
  termsContent11Lbl: string;
  termsContent12Lbl: string;
  termsContent13Lbl: string;
  termsContent14Lbl: string;
  termsContent15Lbl: string;
  termsContent16Lbl: string;
  termsContent17Lbl: string;
  termsContent18Lbl: string;
  termsContent19Lbl: string;
  termsContent20Lbl: string;
  termsContent21Lbl: string;
  termsContent22Lbl: string;
  termsContent23Lbl: string;
  termsContent24Lbl: string;
  termsContent25Lbl: string;
  termsContent26Lbl: string;
  termsContent27Lbl: string;
  termsContent28Lbl: string;
  termsContent29Lbl: string;
  termsContent30Lbl: string;
  termsContent31Lbl: string;
  termsContent32Lbl: string;
  termsContent33Lbl: string;
  termsContent34Lbl: string;
  termsContent35Lbl: string;
  termsContent36Lbl: string;
  termsContent37Lbl: string;
  termsContent38Lbl: string;
  termsContent39Lbl: string;
  termsContent40Lbl: string;
  termsContent41Lbl: string;
  termsContent42Lbl: string;
  termsContent43Lbl: string;
  termsContent44Lbl: string;
  termsContent45Lbl: string;
  termsContent46Lbl: string;
  termsContent47Lbl: string;
  termsContent48Lbl: string;
  termsContent49Lbl: string;
  termsContent50Lbl: string;
  termsContent51Lbl: string;
  termsContent52Lbl: string;
  termsContent53Lbl: string;
  termsContent54Lbl: string;
  termsContent55Lbl: string;
  termsContent56Lbl: string;
  termsContent57Lbl: string;
  termsContent58Lbl: string;
  termsContent59Lbl: string;
  termsContent60Lbl: string;
  termsContent61Lbl: string;
  termsContent62Lbl: string;
  termsContent63Lbl: string;
  termsContent64Lbl: string;
}
//#endregion
//#region header pages and popup labels
export interface IHeaderLabels {
  signInLbl: string;
  signOutLbl: string;
  userNameLbl: string;
  passwordLbl: string;
  forgetPasswordLbl: string;
  newUserLbl: string;
  incorrectUsernameLbl: string;
  userNotActiveLbl: string;
  maxLoginAttemptLbl1: string;
  maxLoginAttemptLbl2: string;
  maxLoginAttemptLbl3: string;
  errorOccuredLbl: string;
  warningMessageLbl: string;
  loggedInCustomerLbl: string;
  changeCustomerLbl: string;
  closeLbl: string;
  saveLbl: string;
  forgetPasswordMessageLbl1: string;
  forgetPasswordUserNameMessageLbl1: string;
  continueLbl: string;
  cancelLbl: string;
  thanksLbl: string;
  newPasswordSentToMailLbl: string;
  okLbl: string;
  loggedInLbl: string;
  accountDetailsForLbl: string;
  nameLbl: string;
  changePasswordLbl: string;
  viewCmpLbl: string;
  accountSummaryLbl: string;
  manageAddressLbl: string;
  manageCompanyLbl: string;
  manageAccountsLbl: string;
  newPasswordLbl: string;
  oldPasswordLbl: string;
  confirmPasswordLbl: string;
  confirmPasswordMatchLbl: string;
  passwordFormatMatchLbl: string;
  passwordSameAsOldLbl: string;
  passwordChangeSuccessfulLbl: string;
  passwordFailedLbl: string;
  changeDefaultPasswordLbl: string;
  passwordUpdateSuccessfulLbl: string;
  termsConditionTitle: string;
  agreeLbl: string;
  disagreeLbl: string;
}
//#endregion
export interface ISearchLabels {

}
